// // import React, { useEffect, useMemo, useRef, useState } from 'react';
// // import { type FormikProps } from 'formik';
// // import { useTranslation } from 'react-i18next';
// // import Loading from '@components/Shared/Loader/Loading';
// // import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
// // import ToastSwal from '@components/Shared/Alert/ToastSwal';
// // import { NumericFormat } from 'react-number-format';

// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { cleanUpItemsList, fetchDataByReferenceId } from '@store/INV/Transactions/InvIssue/invSlice';

// // // ✅ Picker (same as SaleLines)
// // import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// // // ✅ API (same as SaleLines)
// // import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

// // interface LinesProps {
// //   formik: FormikProps<any>;
// //   isUpdate?: boolean;
// // }

// // type ItemType = 'InventoryItem';
// // const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

// // const chunk = <T,>(arr: T[], size: number) => {
// //   const out: T[][] = [];
// //   for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
// //   return out;
// // };

// // const round2 = (v: any) => {
// //   const n = Number(v || 0);
// //   return Math.round((n + Number.EPSILON) * 100) / 100;
// // };

// // const formatNumber = (value: number) =>
// //   new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value || 0));

// // const MoveLines: React.FC<LinesProps> = ({ formik, isUpdate = false }) => {
// //   const { values, setFieldValue } = formik;
// //   const { i18n, t } = useTranslation();
// //   const dispatch = useAppDispatch();

 
// //   // ✅ Picker
// //   const { pickItemUom, modalProps } = useItemUomPicker();

// //   // =========================
// //   // Context
// //   // =========================
// //   const inventoryId: string | null = values?.inventoryId ?? null;
// //   const subInventoryId: string | null = values?.subInventoryId ?? null;
// //   const inventoryTo: string | null = values?.inventoryTo ?? null;

// //   const IsEnabledByCode = () => {
// //     return ['SPR', 'WOI', 'IOI', 'CCA', 'SOI', 'INV', 'MOI', 'MOR', 'IOR', 'BIL', 'POR', 'PIA', 'CRT'].includes(
// //       values.code
// //     );
// //   };
// //   const isDisabled = IsEnabledByCode();

// //   // =========================
// //   // ✅ Details map (ItemId|UOM -> row)
// //   // =========================
// //   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
// //   const [detailsLoading, setDetailsLoading] = useState(false);
// //   const abortRef = useRef<AbortController | null>(null);

// //   const getInfo = (line: any) => {
// //     if (!line?.transactionItemId || !line?.transactionUom) return null;
// //     return detailsMap.get(`${line.transactionItemId}|${line.transactionUom}`) || null;
// //   };

// //   const getItemNameForLine = (line: any) => {
// //     const info = getInfo(line) as any;
// //     const isEn = i18n.language === 'en';
// //     const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
// //     return name || '';
// //   };

// //   const getUomNameForLine = (line: any) => {
// //     const info = getInfo(line) as any;
// //     const isEn = i18n.language === 'en';
// //     const uomName = isEn
// //       ? info?.unitOfMeasureName || info?.unitOfMeasureName2
// //       : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
// //     return uomName || '';
// //   };

// //   const getBarcodeForLine = (line: any) => {
// //     const info = getInfo(line) as any;
// //     return info?.barcode || '';
// //   };

// //   // =========================
// //   // Duplicate rules (item+uom)
// //   // =========================
// //   const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
// //     if (!itemId || !uom) return false;
// //     return (values.materialTransactionsLineList || []).some((l: any, i: number) => {
// //       if (i === excludeIndex) return false;
// //       return String(l?.transactionItemId || '') === String(itemId) && String(l?.transactionUom || '') === String(uom);
// //     });
// //   };

// //   // =========================
// //   // authorizeNegativeStock (like SaleLines)
// //   // =========================
// //   const stockWarnText = () =>
// //     i18n.language === 'en'
// //       ? 'Quantity exceeds available stock (negative selling allowed).'
// //       : 'الكمية أكبر من المتوفر (مسموح السالب).';

// //   const stockBlockText = () =>
// //     i18n.language === 'en' ? 'Quantity exceeds available stock.' : 'الكمية المطلوبة أكبر من المتوفر.';

// //   const getNegativeSellingAllowedForLine = (line: any) => {
// //     const info = getInfo(line) as any;
// //     const v = info?.authorizeNegativeStock ?? line?._authorizeNegativeStock;
// //     return v === true; // فقط true
// //   };

// //   const getAvailableQtyForLine = (line: any): number | null => {
// //     // update-mode: لو عندك RemainingQty من المصدر
// //     if (isUpdate && line?.RemainingQty != null && Number.isFinite(Number(line.RemainingQty))) {
// //       return Math.max(0, Number(line.RemainingQty));
// //     }

// //     const info = getInfo(line) as any;
// //     const q = info?.quentity;
// //     if (q == null || q === '') return null;

// //     const n = Number(q);
// //     return Number.isFinite(n) ? Math.max(0, round2(n)) : null;
// //   };

// //   const enforceAvailableQty = (line: any, attemptedQty?: number) => {
// //     const availRaw = getAvailableQtyForLine(line);
// //     const desired = Math.max(0, round2(attemptedQty ?? line.transactionQuantityIn ?? 0));

// //     line._availableQty = availRaw;
// //     line._qtyOver = false;
// //     line._qtyOverMode = null;

// //     // unknown availability => allow
// //     if (availRaw == null) {
// //       line.transactionQuantityIn = desired;
// //       return true;
// //     }

// //     const available = Math.max(0, round2(availRaw));
// //     line._availableQty = available;

// //     const allowNeg = getNegativeSellingAllowedForLine(line);

// //     if (desired > available) {
// //       if (allowNeg) {
// //         // ✅ allow with warning
// //         line.transactionQuantityIn = desired;
// //         line._qtyOver = true;
// //         line._qtyOverMode = 'WARN';
// //         return true;
// //       }

// //       // ✅ block: clamp
// //       line.transactionQuantityIn = available;
// //       line._qtyOver = true;
// //       line._qtyOverMode = 'BLOCK';
// //       return false;
// //     }

// //     line.transactionQuantityIn = desired;
// //     return true;
// //   };

// //   // =========================
// //   // linesKey (reload details only when itemId/uom changes)
// //   // =========================
// //   const linesKey = useMemo(() => {
// //     const ls = values.materialTransactionsLineList || [];
// //     return ls.map((l: any) => `${l?.transactionItemId || ''}:${l?.transactionUom || ''}`).join('|');
// //   }, [values.materialTransactionsLineList]);

// //   // =========================
// //   // Update-mode: load missing details
// //   // =========================
// //   useEffect(() => {
// //     const run = async () => {
// //       if (!inventoryId) return;

// //       const ls = values.materialTransactionsLineList || [];
// //       const valid = ls.filter((l: any) => l?.transactionItemId && l?.transactionUom);
// //       if (!valid.length) return;

// //       const missingItemIds = new Set<string>();
// //       for (const l of valid) {
// //         const key = `${l.transactionItemId}|${l.transactionUom}`;
// //         if (!detailsMap.has(key)) missingItemIds.add(String(l.transactionItemId));
// //       }
// //       if (!missingItemIds.size) return;

// //       abortRef.current?.abort();
// //       abortRef.current = new AbortController();

// //       setDetailsLoading(true);
// //       try {
// //         const merged = new Map(detailsMap);

// //         const params: any = {
// //           InventoryId: inventoryId,
// //           Scope: 1
// //         };
// //         if (subInventoryId) params.SubInventoryId = subInventoryId;

// //         // ✅ إذا عندكم فلترة لمخزن "إلى" في الباك-إند
// //         if (inventoryTo) params.InventoryId = inventoryTo;

// //         const ids = Array.from(missingItemIds);
// //         for (const idsChunk of chunk(ids, 200)) {
// //           const resp = await fetchItemsWithUomLookup(
// //             params,
// //             {
// //               pageIndex: 1,
// //               pageSize: 1500,
// //               itemType: DEFAULT_ITEM_TYPE,
// //               itemIds: idsChunk
// //             } as any,
// //             abortRef.current.signal
// //           );

// //           for (const r of resp.data?.data || []) {
// //             merged.set(`${(r as any).itemId}|${(r as any).unitOfMeasure}`, r);
// //           }
// //         }

// //         setDetailsMap(merged);
// //       } catch (e: any) {
// //         if (e?.name !== 'CanceledError') console.error(e);
// //       } finally {
// //         setDetailsLoading(false);
// //       }
// //     };

// //     if (isUpdate === true) run();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [inventoryId, subInventoryId, inventoryTo, linesKey, isUpdate]);

// //   // clear details when context changes
// //   useEffect(() => {
// //     setDetailsMap(new Map());
// //     loadedUomsRef.current.clear();
// //   }, [inventoryId, subInventoryId, inventoryTo]);

// //   // =========================
// //   // UOM options per item
// //   // =========================
// //   const uomsByItemId = useMemo(() => {
// //     const map = new Map<string, ItemWithUomRow[]>();
// //     for (const r of detailsMap.values()) {
// //       const itemId = String((r as any)?.itemId ?? '');
// //       if (!itemId) continue;
// //       const list = map.get(itemId) ?? [];
// //       list.push(r);
// //       map.set(itemId, list);
// //     }

// //     for (const [itemId, list] of map.entries()) {
// //       const uniq = new Map<string, ItemWithUomRow>();
// //       for (const r of list) uniq.set(String((r as any).unitOfMeasure), r);
// //       map.set(itemId, Array.from(uniq.values()));
// //     }

// //     return map;
// //   }, [detailsMap]);

// //   const loadedUomsRef = useRef(new Set<string>());
// //   const uomsAbortRef = useRef<AbortController | null>(null);
// //   const [uomsLoading, setUomsLoading] = useState(false);

// //   const ensureItemUomsLoaded = async (itemId: string) => {
// //     if (!inventoryId || !itemId) return;

// //     const key = `${inventoryId}|${subInventoryId || ''}|${inventoryTo || ''}|${DEFAULT_ITEM_TYPE}|${itemId}`;
// //     if (loadedUomsRef.current.has(key)) return;
// //     loadedUomsRef.current.add(key);

// //     try {
// //       uomsAbortRef.current?.abort();
// //       uomsAbortRef.current = new AbortController();
// //       setUomsLoading(true);

// //       const params: any = { InventoryId: inventoryId, Scope: 1 };
// //       if (subInventoryId) params.SubInventoryId = subInventoryId;
// //       if (inventoryTo) params.InventoryId = inventoryTo;

// //       const resp = await fetchItemsWithUomLookup(
// //         params,
// //         {
// //           pageIndex: 1,
// //           pageSize: 3000,
// //           itemType: DEFAULT_ITEM_TYPE,
// //           itemIds: [itemId]
// //         } as any,
// //         uomsAbortRef.current.signal
// //       );

// //       const list: ItemWithUomRow[] = resp?.data?.data || [];
// //       if (!Array.isArray(list) || list.length === 0) return;

// //       setDetailsMap(prev => {
// //         const merged = new Map(prev);
// //         for (const r of list) merged.set(`${(r as any).itemId}|${(r as any).unitOfMeasure}`, r);
// //         return merged;
// //       });
// //     } catch (e: any) {
// //       if (e?.name !== 'CanceledError') {
// //         loadedUomsRef.current.delete(key);
// //         console.error(e);
// //       }
// //     } finally {
// //       setUomsLoading(false);
// //     }
// //   };

// //   // =========================
// //   // Barcode quick add (like SaleLines)
// //   // =========================
// //   const barcodeInputRef = useRef<HTMLInputElement | null>(null);
// //   const barcodeAbortRef = useRef<AbortController | null>(null);
// //   const [barcodeTerm, setBarcodeTerm] = useState('');
// //   const [barcodeLoading, setBarcodeLoading] = useState(false);

// //   const [barcodeMsg, setBarcodeMsg] = useState<string | null>(null);
// //   const [barcodeMsgType, setBarcodeMsgType] = useState<'warn' | 'error' | null>(null);

// //   useEffect(() => {
// //     setBarcodeMsg(null);
// //     setBarcodeMsgType(null);
// //     if (!inventoryId) return;
// //     const h = window.setTimeout(() => barcodeInputRef.current?.focus(), 50);
// //     return () => window.clearTimeout(h);
// //   }, [inventoryId, subInventoryId, inventoryTo]);

// //   const pickBestRowForBarcode = (rows: ItemWithUomRow[]) => {
// //     if (!Array.isArray(rows) || rows.length === 0) return null;
// //     return (rows as any).find((r: any) => r?.isPrimaryUOM) || rows[0];
// //   };

// //   const addLineByBarcode = async (rawBarcode: string) => {
// //     const barcode = String(rawBarcode || '').trim();
// //     if (!barcode) return;

// //     setBarcodeMsg(null);
// //     setBarcodeMsgType(null);

// //     if (!inventoryId) {
// //       setBarcodeMsg(i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.');
// //       setBarcodeMsgType('error');
// //       barcodeInputRef.current?.focus();
// //       return;
// //     }

// //     if (isDisabled) return;

// //     barcodeAbortRef.current?.abort();
// //     barcodeAbortRef.current = new AbortController();

// //     setBarcodeLoading(true);
// //     try {
// //       const params: any = { InventoryId: inventoryId, Scope: 1 };
// //       if (subInventoryId) params.SubInventoryId = subInventoryId;
// //       if (inventoryTo) params.InventoryId = inventoryTo;

// //       const resp = await fetchItemsWithUomLookup(
// //         params,
// //         {
// //           pageIndex: 1,
// //           pageSize: 30,
// //           itemType: DEFAULT_ITEM_TYPE,
// //           barcodeEqual: barcode
// //         } as any,
// //         barcodeAbortRef.current.signal
// //       );

// //       const list: ItemWithUomRow[] = resp?.data?.data || [];
// //       const picked = pickBestRowForBarcode(list) as any;

// //       if (!picked?.itemId || !picked?.unitOfMeasure) {
// //         setBarcodeMsg(i18n.language === 'en' ? 'Barcode not found.' : 'لا يوجد صنف بهذا الباركود.');
// //         setBarcodeMsgType('error');
// //         barcodeInputRef.current?.focus();
// //         return;
// //       }

// //       const allowNegPicked = picked?.authorizeNegativeStock === true;

// //       // cache row
// //       setDetailsMap(prev => {
// //         const m = new Map(prev);
// //         m.set(`${picked.itemId}|${picked.unitOfMeasure}`, picked);
// //         return m;
// //       });

// //       // preload UOMs
// //       ensureItemUomsLoaded(String(picked.itemId));

// //       const currentLines = [...(values.materialTransactionsLineList || [])];

// //       const existingIndex = currentLines.findIndex(
// //         (l: any) =>
// //           String(l?.transactionItemId || '') === String(picked.itemId) &&
// //           String(l?.transactionUom || '') === String(picked.unitOfMeasure)
// //       );

// //       if (existingIndex >= 0) {
// //         const line = { ...currentLines[existingIndex] };
// //         const desired = Number(line.transactionQuantityIn || 0) + 1;

// //         line._authorizeNegativeStock = allowNegPicked;

// //         const ok = enforceAvailableQty(line, desired);
// //         if (!ok && !allowNegPicked) {
// //           setBarcodeMsg(stockBlockText());
// //           setBarcodeMsgType('error');
// //           barcodeInputRef.current?.focus();
// //           return;
// //         }
// //         if (line._qtyOverMode === 'WARN') {
// //           setBarcodeMsg(stockWarnText());
// //           setBarcodeMsgType('warn');
// //         }

// //         currentLines[existingIndex] = line;
// //         formik.setFieldValue('materialTransactionsLineList', currentLines);
// //       } else {
// //         const newLine: any = {
// //           id: null,
// //           transactionItemId: picked.itemId,
// //           transactionUom: picked.unitOfMeasure,
// //           unitPrice: 0,
// //           transactionQuantityIn: 1,
// //           transactionQuantityOut: 0,
// //           lotId: null,

// //           inventoryId: '',
// //           discount: 0,
// //           codeCombinationId: '',
// //           currencyCode: '',
// //           currencyConversionRate: 0,
// //           referenceIdMaster: '',
// //           referenceIdLine: '',
// //           transactionTypeId: '',
// //           equivalent: 0,
// //           expensesAmount: 0,
// //           batchId: '',

// //           _availableQty: null,
// //           _qtyOver: false,
// //           _qtyOverMode: null,
// //           _authorizeNegativeStock: allowNegPicked
// //         };

// //         const ok = enforceAvailableQty(newLine, newLine.transactionQuantityIn);
// //         if (!ok && !allowNegPicked) {
// //           setBarcodeMsg(stockBlockText());
// //           setBarcodeMsgType('error');
// //           barcodeInputRef.current?.focus();
// //           return;
// //         }
// //         if (newLine._qtyOverMode === 'WARN') {
// //           setBarcodeMsg(stockWarnText());
// //           setBarcodeMsgType('warn');
// //         }

// //         formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
// //       }

// //       setBarcodeTerm('');
// //       barcodeInputRef.current?.focus();
// //     } catch (e: any) {
// //       if (e?.name !== 'CanceledError') {
// //         console.error(e);
// //         setBarcodeMsg(i18n.language === 'en' ? 'Failed to lookup barcode.' : 'تعذر البحث عن الباركود.');
// //         setBarcodeMsgType('error');
// //       }
// //     } finally {
// //       setBarcodeLoading(false);
// //     }
// //   };

// //   // =========================
// //   // Line handlers
// //   // =========================
// //   const resetLine = (line: any) => ({
// //     ...line,
// //     transactionItemId: null,
// //     transactionUom: '',
// //     transactionQuantityIn: 0,
// //     lotId: null,
// //     _availableQty: null,
// //     _qtyOver: false,
// //     _qtyOverMode: null,
// //     _authorizeNegativeStock: null
// //   });

// //   const handleAddLine = () => {
// //     const newLine: any = {
// //       id: null,
// //       transactionItemId: null,
// //       transactionUom: '',
// //       unitPrice: 0,
// //       transactionQuantityIn: 0,
// //       transactionQuantityOut: 0,
// //       lotId: null,

// //       inventoryId: '',
// //       discount: 0,
// //       codeCombinationId: '',
// //       currencyCode: '',
// //       currencyConversionRate: 0,
// //       referenceIdMaster: '',
// //       referenceIdLine: '',
// //       transactionTypeId: '',
// //       equivalent: 0,
// //       expensesAmount: 0,
// //       batchId: '',

// //       _availableQty: null,
// //       _qtyOver: false,
// //       _qtyOverMode: null,
// //       _authorizeNegativeStock: null
// //     };

// //     const currentLines = values.materialTransactionsLineList || [];
// //     formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
// //   };

// //   const handleDeleteLine = (index: number) => {
// //     const updatedLines = (values.materialTransactionsLineList || []).filter((_: any, i: number) => i !== index);
// //     formik.setFieldValue('materialTransactionsLineList', updatedLines);
// //   };

// //   const handleLineChange = (index: number, field: string, value: any) => {
// //     const updated = [...(values.materialTransactionsLineList || [])];
// //     if (!updated[index]) return;

// //     const line = { ...updated[index] };

// //     if (field === 'clearItem') {
// //       updated[index] = resetLine(line);
// //       formik.setFieldValue('materialTransactionsLineList', updated);
// //       return;
// //     }

// //     if (field === 'transactionUom') {
// //       if (line.transactionItemId && lineHasDuplicateItemUom(line.transactionItemId, value, index)) {
// //         ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
// //         return;
// //       }

// //       const next = { ...line, transactionUom: value };

// //       // لو الصف الجديد موجود في detailsMap فالفلاج بيجي منه، وإلا يبقى من السطر
// //       const ok = enforceAvailableQty(next, next.transactionQuantityIn);

// //       if (!ok && !getNegativeSellingAllowedForLine(next)) {
// //         ToastSwal({ position: 'bottom-start', text: stockBlockText() });
// //       } else if (next._qtyOverMode === 'WARN') {
// //         ToastSwal({ position: 'bottom-start', text: stockWarnText() });
// //       }

// //       updated[index] = next;
// //       formik.setFieldValue('materialTransactionsLineList', updated);
// //       return;
// //     }

// //     if (field === 'transactionQuantityIn') {
// //       const next = { ...line, transactionQuantityIn: value };

// //       const ok = enforceAvailableQty(next, value);

// //       if (!ok && !getNegativeSellingAllowedForLine(next)) {
// //         ToastSwal({ position: 'bottom-start', text: stockBlockText() });
// //       } else if (next._qtyOverMode === 'WARN') {
// //         ToastSwal({ position: 'bottom-start', text: stockWarnText() });
// //       }

// //       updated[index] = next;
// //       formik.setFieldValue('materialTransactionsLineList', updated);
// //       return;
// //     }

// //     updated[index] = { ...line, [field]: value };
// //     formik.setFieldValue('materialTransactionsLineList', updated);
// //   };

// //   // =========================
// //   // Open picker for line (same concept as SaleLines)
// //   // =========================
// //   const openPickerForLine = async (lineIndex: number) => {
// //     const ls = values.materialTransactionsLineList || [];
// //     const line = ls[lineIndex];
// //     if (!line) return;

// //     if (!inventoryId) {
// //       ToastSwal({
// //         position: 'bottom-start',
// //         text: i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.'
// //       });
// //       return;
// //     }

// //     if (isDisabled) return;

// //     const params: any = {
// //       InventoryId: inventoryId,
// //       Scope: 1
// //     };
// //     if (subInventoryId) params.SubInventoryId = subInventoryId;
// //     if (inventoryTo) params.InventoryId = inventoryTo;

// //     const picked = await pickItemUom({
// //       title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار الصنف',
// //       params,
// //       bodyDefaults: { itemType: DEFAULT_ITEM_TYPE },
// //       pageSize: 10,
// //       searchMode: 'manual',
// //       initialSearchField: 'barcodeEqual',
// //       isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex),
// //       // dynamicFields: ['quentity', 'barcode', 'authorizeNegativeStock'] // ✅ enabled
// //       dynamicFields: ['quentity', 'barcode'] // ✅ enabled
// //     });

// //     if (!picked) return;

// //     const row: any = picked.row;
// //     if (!row?.itemId || !row?.unitOfMeasure) return;

// //     if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
// //       ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
// //       return;
// //     }

// //     const allowNeg = row?.authorizeNegativeStock === true;
// //     const rowAvail = Number(row?.quentity);
// //     const hasRowAvail = Number.isFinite(rowAvail);

// //     // ✅ إذا الكمية الحالية أكبر من المتوفر + غير مسموح بالسالب => امنع الاختيار
// //     const currentQty = Number(line?.transactionQuantityIn || 0);
// //     if (hasRowAvail && currentQty > rowAvail && !allowNeg) {
// //       ToastSwal({ position: 'bottom-start', text: stockBlockText() });
// //       return;
// //     }
// //     if (hasRowAvail && currentQty > rowAvail && allowNeg) {
// //       ToastSwal({ position: 'bottom-start', text: stockWarnText() });
// //     }

// //     // cache row
// //     setDetailsMap(prev => {
// //       const m = new Map(prev);
// //       m.set(`${row.itemId}|${row.unitOfMeasure}`, row);
// //       return m;
// //     });

// //     const updated = [...ls];
// //     const currentLine = { ...updated[lineIndex] };

// //     updated[lineIndex] = {
// //       ...currentLine,
// //       transactionItemId: row.itemId,
// //       transactionUom: row.unitOfMeasure,
// //       _authorizeNegativeStock: allowNeg
// //     };

// //     const ok = enforceAvailableQty(updated[lineIndex], Number(updated[lineIndex].transactionQuantityIn || 0));

// //     if (!ok && !getNegativeSellingAllowedForLine(updated[lineIndex])) {
// //       ToastSwal({ position: 'bottom-start', text: stockBlockText() });
// //     } else if (updated[lineIndex]._qtyOverMode === 'WARN') {
// //       ToastSwal({ position: 'bottom-start', text: stockWarnText() });
// //     }

// //     formik.setFieldValue('materialTransactionsLineList', updated);

// //     ensureItemUomsLoaded(String(row.itemId));
// //   };

// //   // =========================
// //   // Reference fetch (keep your old logic)
// //   // =========================
// //   const { itemsList, loading: loading1 } = useAppSelector(state => state.Inv);

// //   const updateFieldsBasedOnCode = (data: any) => {
// //     setFieldValue('referenceCode', data?.data?.code);

// //     switch (values.code) {
// //       case 'INV':
// //         setFieldValue('customerId', data?.data?.peopleId ?? null);
// //         setFieldValue('inventoryId', data?.data?.inventoryId);
// //         break;
// //       case 'SOI':
// //         setFieldValue('customerId', data?.data?.peopleId ?? null);
// //         setFieldValue('supplierId', null);
// //         break;
// //       case 'IOI':
// //         setFieldValue('subInventoryId', data?.data?.subInventoryId);
// //         setFieldValue('inventoryId', data?.data?.inventoryId);
// //         break;
// //       case 'SPR':
// //         setFieldValue('supplierId', data?.data?.peopleId ?? null);
// //         setFieldValue('customerId', null);
// //         break;
// //       case 'BIL':
// //         setFieldValue('supplierId', data?.data?.peopleId);
// //         setFieldValue('customerId', null);
// //         break;
// //       case 'CRT':
// //         setFieldValue('supplierId', null);
// //         setFieldValue('customerId', data?.data?.peopleId);
// //         break;
// //       case 'IOR':
// //         setFieldValue('branchId', data?.data?.branchId);
// //         break;
// //       default:
// //         break;
// //     }
// //   };

// //   useEffect(() => {
// //     if (['MII', 'MIR'].includes(values.code)) return;

// //     if (values.referenceId) {
// //       dispatch(fetchDataByReferenceId({ referenceId: values.referenceId, code: values.code }))
// //         .unwrap()
// //         .then(({ data }) => updateFieldsBasedOnCode(data))
// //         .catch(error => console.error('Failed to fetch data:', error));
// //     }

// //     return () => {
// //       dispatch(cleanUpItemsList());
// //     };
// //   }, [values.referenceId, values.code]);

// //   useEffect(() => {
// //     // keep your behavior: load lines from itemsList when not update
// //     if (isUpdate === false) {
// //       formik.setFieldValue('materialTransactionsLineList', itemsList);
// //     } else {
// //       const list = (values.materialTransactionsLineList || []).map((m: any) => {
// //         const targetItem: any = (itemsList || []).find((f: any) => f.transactionItemId === m.transactionItemId);
// //         return {
// //           ...m,
// //           RealQty: targetItem?.RealQty,
// //           RemainingQty: Number(m?.transactionQuantityIn) + Number(targetItem?.RemainingQty),
// //           dispensedQuantity: Number(targetItem?.dispensedQuantity) - Number(m?.transactionQuantityIn)
// //         };
// //       });
// //       formik.setFieldValue('materialTransactionsLineList', list);
// //     }
// //   }, [itemsList]);

// //   // =========================
// //   // UI
// //   // =========================
// //   const Lines: any[] = values.materialTransactionsLineList?.slice() || [];

// //   return (
// //     <>
// //       <Loading loading={loading1} Type='Dots'>
// //         <ItemUomPickerModal {...modalProps} />

// //         <div className='mb-3'>
// //           {/* ✅ barcode + add */}
// //           <div className='row mb-2'>
// //             <div className='col-lg-9'>
// //               <div className='position-relative' style={{ maxWidth: 420 }}>
// //                 <div className='input-group input-group-sm'>
// //                   <span className='input-group-text'>
// //                     <i className='fas fa-barcode text-muted'></i>
// //                   </span>

// //                   <input
// //                     ref={barcodeInputRef}
// //                     value={barcodeTerm}
// //                     onChange={e => {
// //                       setBarcodeTerm(e.target.value);
// //                       if (barcodeMsg) {
// //                         setBarcodeMsg(null);
// //                         setBarcodeMsgType(null);
// //                       }
// //                     }}
// //                     onKeyDown={e => {
// //                       if (e.key === 'Enter') {
// //                         e.preventDefault();
// //                         addLineByBarcode(barcodeTerm);
// //                       }
// //                       if (e.key === 'Escape') {
// //                         setBarcodeTerm('');
// //                         setBarcodeMsg(null);
// //                         setBarcodeMsgType(null);
// //                       }
// //                     }}
// //                     className='form-control'
// //                     disabled={!inventoryId || barcodeLoading || isDisabled}
// //                     placeholder={t('امسح الباركود أو أدخل الرقم')}
// //                     inputMode='numeric'
// //                   />

// //                   {barcodeLoading ? (
// //                     <span className='input-group-text'>
// //                       <span className='spinner-border spinner-border-sm text-theme' />
// //                     </span>
// //                   ) : (
// //                     <button
// //                       className='input-group-text'
// //                       onClick={() => barcodeTerm && addLineByBarcode(barcodeTerm)}
// //                       disabled={!barcodeTerm || barcodeLoading || !inventoryId || isDisabled}
// //                       title={t('إضافة')}
// //                     >
// //                       <i className='fas fa-plus text-theme'></i>
// //                     </button>
// //                   )}
// //                 </div>

// //                 {barcodeMsg && (
// //                   <div className='position-absolute top-100 start-0 mt-1 w-100' style={{ zIndex: 1025 }}>
// //                     <div
// //                       className={`alert alert-sm py-1 mb-0 d-flex align-items-center ${
// //                         barcodeMsgType === 'warn' ? 'alert-warning' : 'alert-danger'
// //                       }`}
// //                     >
// //                       <i
// //                         className={`fas me-2 ${
// //                           barcodeMsgType === 'warn' ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'
// //                         }`}
// //                       ></i>
// //                       <small>{barcodeMsg}</small>
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>

// //               {detailsLoading && isUpdate && (
// //                 <div className='mt-2 text-muted small'>
// //                   <span className='spinner-border spinner-border-sm text-theme me-2'></span>
// //                   {t('جاري تحميل التفاصيل...')}
// //                 </div>
// //               )}
// //             </div>

// //             <div className='col-lg-3 text-end'>
// //               {!isDisabled && (
// //                 <button type='button' className='btn btn-theme' onClick={handleAddLine}>
// //                   {t('إضافة صنف')}
// //                 </button>
// //               )}
// //             </div>
// //           </div>

// //           <div
// //             className={`table-responsive rounded-2 text-center ${
// //               formik.errors.materialTransactionsLineList ? 'border-bottom border-2 border-danger' : ''
// //             }`}
// //           >
// //             <table className='table table-borderless table-hover mb-0'>
// //               <thead className='bg-theme bg-opacity-30'>
// //                 <tr>
// //                   <th className='align-middle' style={{ width: '3%' }}>
// //                     !
// //                   </th>
// //                   <th className='align-middle' style={{ width: '48%' }}>
// //                     {t('اسم الصنف')}
// //                   </th>
// //                   <th className='align-middle' style={{ width: '15%' }}>
// //                     {t('الوحدة')}
// //                   </th>
// //                   <th className='align-middle' style={{ width: '15%' }}>
// //                     {t('رقم التشغيل')}
// //                   </th>
// //                   <th className='align-middle' style={{ width: '8%' }}>
// //                     {t('الكمية')}
// //                   </th>
// //                   <th className='align-middle text-end' style={{ width: '3%' }}></th>
// //                 </tr>
// //               </thead>

// //               <tbody className='fw-bold'>
// //                 {[...Lines].reverse().map((line: any, revIndex: number) => {
// //                   const Index = Lines.length - 1 - revIndex;

// //                   const info = getInfo(line) as any;
// //                   const itemName = line.transactionItemId ? getItemNameForLine(line) : '';
// //                   const uomName = line.transactionItemId ? getUomNameForLine(line) : '';
// //                   const barcode = line.transactionItemId ? getBarcodeForLine(line) : '';

// //                   const uomOptions = line.transactionItemId
// //                     ? uomsByItemId.get(String(line.transactionItemId)) || []
// //                     : [];

// //                   const isDuplicate =
// //                     line.transactionItemId &&
// //                     line.transactionUom &&
// //                     (values.materialTransactionsLineList || []).some(
// //                       (l: any, i: number) =>
// //                         i !== Index &&
// //                         String(l?.transactionItemId || '') === String(line.transactionItemId) &&
// //                         String(l?.transactionUom || '') === String(line.transactionUom || '')
// //                     );

// //                   const availableQty = getAvailableQtyForLine(line);
// //                   const hasAvail = availableQty != null;

// //                   const allowNegLine = getNegativeSellingAllowedForLine(line);
// //                   const qtyOver = Boolean(line?._qtyOver);
// //                   const isBlock = qtyOver && String(line?._qtyOverMode || '') === 'BLOCK';
// //                   const overText = allowNegLine ? stockWarnText() : stockBlockText();

// //                   // ✅ Lots (إذا كانت راجعة من lookup row)
// //                   const lots: any[] = Array.isArray(info?.qtyByLot) ? info.qtyByLot : [];
// //                   const sumLots = lots.reduce((s: number, x: any) => s + Number(x?.qty || 0), 0);

// //                   return (
// //                     <tr key={Index}>
// //                       <td className='align-middle small'>
// //                         <button type='button' className='btn btn-link text-theme p-0'>
// //                           <i className='bi bi-info-circle fa-lg'></i>
// //                         </button>
// //                       </td>

// //                       {/* ✅ Item cell (SaleLines style) */}
// //                       <td className='align-middle small'>
// //                         <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
// //                           <div className='d-flex align-items-start gap-2'>
// //                             <div className='flex-grow-1' style={{ minWidth: 0 }}>
// //                               {line.transactionItemId ? (
// //                                 <>
// //                                   <span className='fw-bold text-truncate d-block'>
// //                                     {itemName ||
// //                                       (detailsLoading
// //                                         ? i18n.language === 'en'
// //                                           ? 'Loading...'
// //                                           : '...جاري التحميل'
// //                                         : `ID: ${line.transactionItemId}`)}
// //                                   </span>

// //                                   <small className='text-muted d-block'>
// //                                     {t('الوحدة')}:{' '}
// //                                     <span className='fw-bold text-theme'>{uomName || line.transactionUom || '-'}</span>
// //                                     <span className='mx-2'>•</span>
// //                                     {t('باركود')}: <span className='fw-bold'>{barcode || '-'}</span>
// //                                   </small>
// //                                 </>
// //                               ) : (
// //                                 <span className='text-muted'>{t('اختر الصنف')}</span>
// //                               )}

// //                               {isDuplicate && (
// //                                 <small className='text-danger d-block mt-1'>
// //                                   <i className='fas fa-exclamation-triangle me-1'></i>
// //                                   {t('هذا الصنف مكرر مع نفس الوحدة')}
// //                                 </small>
// //                               )}
// //                             </div>

// //                             <div className='d-flex gap-1'>
// //                               <button
// //                                 type='button'
// //                                 className='btn btn-sm btn-theme rounded-0'
// //                                 onClick={() => openPickerForLine(Index)}
// //                                 disabled={!inventoryId || isDisabled}
// //                                 title={!inventoryId ? t('يجب اختيار المخزن أولاً.') : t('اختيار صنف ووحدة')}
// //                               >
// //                                 <i className='fas fa-search me-1'></i>
// //                                 {line.transactionItemId ? t('تغيير') : t('اختيار')}
// //                               </button>

// //                               {line.transactionItemId && (
// //                                 <button
// //                                   type='button'
// //                                   className='btn btn-sm btn-outline-danger rounded-0'
// //                                   onClick={() => handleLineChange(Index, 'clearItem', true)}
// //                                   title={t('مسح الصنف')}
// //                                   disabled={isDisabled}
// //                                 >
// //                                   <i className='fas fa-times'></i>
// //                                 </button>
// //                               )}
// //                             </div>
// //                           </div>
// //                         </div>
// //                       </td>

// //                       {/* ✅ UOM select */}
// //                       <td className='align-middle small'>
// //                         <select
// //                           disabled={!line.transactionItemId || isDisabled}
// //                           className={`form-select text-center ${isDuplicate ? 'border-danger' : 'border-theme'}`}
// //                           value={line.transactionUom || ''}
// //                           onFocus={() => {
// //                             if (line.transactionItemId) ensureItemUomsLoaded(String(line.transactionItemId));
// //                           }}
// //                           onChange={e => handleLineChange(Index, 'transactionUom', e.target.value)}
// //                         >
// //                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

// //                           {line.transactionUom && uomOptions.length === 0 && (
// //                             <option value={line.transactionUom}>{uomName || line.transactionUom}</option>
// //                           )}

// //                           {uomOptions.map((u: any) => {
// //                             const isEn = i18n.language === 'en';
// //                             const label =
// //                               (isEn
// //                                 ? u?.unitOfMeasureName || u?.unitOfMeasureName2
// //                                 : u?.unitOfMeasureName2 || u?.unitOfMeasureName) || `ID: ${u?.unitOfMeasure}`;

// //                             return (
// //                               <option key={String(u?.unitOfMeasure)} value={String(u?.unitOfMeasure)}>
// //                                 {label}
// //                               </option>
// //                             );
// //                           })}

// //                           {uomsLoading && line.transactionItemId ? (
// //                             <option value={line.transactionUom || ''} disabled>
// //                               {i18n.language === 'en' ? 'Loading...' : '...جاري التحميل'}
// //                             </option>
// //                           ) : null}
// //                         </select>
// //                       </td>

// //                       {/* ✅ Lot */}
// //                       <td className='align-middle small'>
// //                         <PopoverCustom
// //                           childern={
// //                             <select
// //                               className='form-select text-center'
// //                               value={line.lotId || ''}
// //                               onChange={e => handleLineChange(Index, 'lotId', e.target.value)}
// //                               disabled={!line.transactionItemId || !line.transactionUom || isDisabled}
// //                             >
// //                               <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

// //                               {lots
// //                                 ?.filter((x: any) => x?.lotId)
// //                                 ?.map((x: any) => (
// //                                   <option key={x.lotId} value={x.lotId || ''}>
// //                                     {x.lotNumber || x.lotId}
// //                                   </option>
// //                                 ))}
// //                             </select>
// //                           }
// //                           Header='تفاصيل الصنف'
// //                           Body={
// //                             <>
// //                               <div className='d-flex justify-content-between'>
// //                                 <span className='mt-1'>{t('المتوفر')}</span>
// //                                 <span className='text-theme fw-bold fs-6 mx-2'>
// //                                   {hasAvail
// //                                     ? formatNumber(Number(availableQty || 0))
// //                                     : formatNumber(Number(sumLots || 0))}
// //                                 </span>
// //                               </div>

// //                               {line.lotId && lots?.length > 0 ? (
// //                                 <>
// //                                   <div className='d-flex justify-content-between'>
// //                                     <span className='mt-1'>{t('الكمية')}</span>
// //                                     <span className='text-theme fw-bold fs-6 mx-2'>
// //                                       {formatNumber(
// //                                         Number(lots.find((x: any) => String(x?.lotId) === String(line.lotId))?.qty || 0)
// //                                       )}
// //                                     </span>
// //                                   </div>

// //                                   <div className='d-flex justify-content-between'>
// //                                     <span className='mt-1'>{t('تاريخ الإنتهاء')}</span>
// //                                     <span className='text-theme fw-bold fs-6 mx-2'>
// //                                       {String(
// //                                         lots.find((x: any) => String(x?.lotId) === String(line.lotId))
// //                                           ?.expirationDate || ''
// //                                       )
// //                                         ?.toString()
// //                                         ?.split('T')[0] || '-'}
// //                                     </span>
// //                                   </div>
// //                                 </>
// //                               ) : null}
// //                             </>
// //                           }
// //                         />
// //                       </td>

// //                       {/* ✅ Qty */}
// //                       <td className='align-middle small'>
// //                         <div style={{ width: '100%' }}>
// //                           <NumericFormat
// //                             value={line.transactionQuantityIn}
// //                             thousandSeparator=','
// //                             decimalSeparator='.'
// //                             decimalScale={0}
// //                             allowNegative={false}
// //                             className={`form-control text-center px-0 bg-body ${
// //                               isBlock ? 'border-danger' : qtyOver ? 'border-warning' : 'border-theme'
// //                             }`}
// //                             disabled={!line.transactionItemId || isDisabled}
// //                             onValueChange={v => handleLineChange(Index, 'transactionQuantityIn', v.floatValue ?? 0)}
// //                           />

// //                           {hasAvail && (
// //                             <small className='d-block mt-1 text-muted'>
// //                               {i18n.language === 'en' ? 'Available:' : 'المتوفر:'}{' '}
// //                               <span className='fw-bold'>{formatNumber(Number(availableQty || 0))}</span>
// //                             </small>
// //                           )}

// //                           {qtyOver && (
// //                             <small className={`${isBlock ? 'text-danger' : 'text-warning'} d-block mt-1`}>
// //                               <i className='fas fa-exclamation-triangle me-1'></i>
// //                               {overText}
// //                             </small>
// //                           )}
// //                         </div>
// //                       </td>

// //                       {/* ✅ delete */}
// //                       <td className='align-middle small'>
// //                         <button
// //                           type='button'
// //                           className='btn btn-outline-danger'
// //                           onClick={() => handleDeleteLine(Index)}
// //                           disabled={isDisabled}
// //                         >
// //                           <i className='fas fa-trash-alt'></i>
// //                         </button>
// //                       </td>
// //                     </tr>
// //                   );
// //                 })}

// //                 {Lines.length === 0 ? (
// //                   <tr>
// //                     <td colSpan={6} className='text-center py-4 text-muted'>
// //                       {t('لا توجد بنود')}
// //                       {!isDisabled && (
// //                         <div className='mt-2'>
// //                           <button type='button' className='btn btn-theme' onClick={handleAddLine}>
// //                             <i className='fas fa-plus me-2'></i>
// //                             {t('إضافة أول بند')}
// //                           </button>
// //                         </div>
// //                       )}
// //                     </td>
// //                   </tr>
// //                 ) : null}
// //               </tbody>
// //             </table>

// //             {formik.errors.materialTransactionsLineList?.length ? <div className='text-danger'> * مطلوب </div> : null}
// //           </div>
// //         </div>
// //       </Loading>
// //     </>
// //   );
// // };

// // export default MoveLines;


// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { type FormikProps } from 'formik';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
// import ToastSwal from '@components/Shared/Alert/ToastSwal';
// import { NumericFormat } from 'react-number-format';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { cleanUpItemsList, fetchDataByReferenceId } from '@store/INV/Transactions/InvIssue/invSlice';

// // ✅ Picker (same as SaleLines)
// import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// // ✅ API (same as SaleLines)
// import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

// interface LinesProps {
//   formik: FormikProps<any>;
//   isUpdate?: boolean;
// }

// type ItemType = 'InventoryItem';
// const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

// const chunk = <T,>(arr: T[], size: number) => {
//   const out: T[][] = [];
//   for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
//   return out;
// };

// const round2 = (v: any) => {
//   const n = Number(v || 0);
//   return Math.round((n + Number.EPSILON) * 100) / 100;
// };

// const formatNumber = (value: number) =>
//   new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value || 0));

// const MoveLines: React.FC<LinesProps> = ({ formik, isUpdate = false }) => {
//   const { values, setFieldValue } = formik;
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();

//   // ✅ Picker
//   const { pickItemUom, modalProps } = useItemUomPicker();

//   // =========================
//   // Context
//   // =========================
//   const inventoryId: string | null = values?.inventoryId ?? null;
//   const subInventoryId: string | null = values?.subInventoryId ?? null;
//   // const inventoryTo: string | null = values?.inventoryTo ?? null;

//   // ✅ pricing rule:
//   // 1 => no price column
//   // 2 => show price column (user input)
//   const methodTransfer = Number(values?.methodTransfer ?? 0);
//   const showUnitPrice = methodTransfer === 2;

//   const IsEnabledByCode = () => {
//     return ['SPR', 'WOI', 'IOI', 'CCA', 'SOI', 'INV', 'MOI', 'MOR', 'IOR', 'BIL', 'POR', 'PIA', 'CRT'].includes(
//       values.code
//     );
//   };
//   const isDisabled = IsEnabledByCode();

//   // ✅ إذا methodTransfer != 2: صفّر الأسعار دائماً
//   useEffect(() => {
//     if (showUnitPrice) return;

//     const ls = values.materialTransactionsLineList || [];
//     if (!ls.length) return;

//     const updated = ls.map((l: any) => {
//       if (!l) return l;
//       if (Number(l.unitPrice || 0) === 0) return l;
//       return { ...l, unitPrice: 0 };
//     });

//     const changed = updated.some((u: any, i: number) => Number(u?.unitPrice || 0) !== Number(ls[i]?.unitPrice || 0));
//     if (changed) formik.setFieldValue('materialTransactionsLineList', updated);

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [methodTransfer]);

//   // =========================
//   // ✅ Details map (ItemId|UOM -> row)
//   // =========================
//   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const abortRef = useRef<AbortController | null>(null);

//   const getInfo = (line: any) => {
//     if (!line?.transactionItemId || !line?.transactionUom) return null;
//     return detailsMap.get(`${line.transactionItemId}|${line.transactionUom}`) || null;
//   };

//   const getItemNameForLine = (line: any) => {
//     const info = getInfo(line) as any;
//     const isEn = i18n.language === 'en';
//     const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
//     return name || '';
//   };

//   const getUomNameForLine = (line: any) => {
//     const info = getInfo(line) as any;
//     const isEn = i18n.language === 'en';
//     const uomName = isEn
//       ? info?.unitOfMeasureName || info?.unitOfMeasureName2
//       : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
//     return uomName || '';
//   };

//   const getBarcodeForLine = (line: any) => {
//     const info = getInfo(line) as any;
//     return info?.barcode || '';
//   };

//   // =========================
//   // Duplicate rules (item+uom)
//   // =========================
//   const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
//     if (!itemId || !uom) return false;
//     return (values.materialTransactionsLineList || []).some((l: any, i: number) => {
//       if (i === excludeIndex) return false;
//       return String(l?.transactionItemId || '') === String(itemId) && String(l?.transactionUom || '') === String(uom);
//     });
//   };

//   // =========================
//   // authorizeNegativeStock (like SaleLines)
//   // =========================
//   const stockWarnText = () =>
//     i18n.language === 'en'
//       ? 'Quantity exceeds available stock (negative selling allowed).'
//       : 'الكمية أكبر من المتوفر (مسموح السالب).';

//   const stockBlockText = () =>
//     i18n.language === 'en' ? 'Quantity exceeds available stock.' : 'الكمية المطلوبة أكبر من المتوفر.';

//   const getNegativeSellingAllowedForLine = (line: any) => {
//     const info = getInfo(line) as any;
//     const v = info?.authorizeNegativeStock ?? line?._authorizeNegativeStock;
//     return v === true;
//   };

//   const getAvailableQtyForLine = (line: any): number | null => {
//     if (isUpdate && line?.RemainingQty != null && Number.isFinite(Number(line.RemainingQty))) {
//       return Math.max(0, Number(line.RemainingQty));
//     }

//     const info = getInfo(line) as any;
//     const q = info?.quentity;
//     if (q == null || q === '') return null;

//     const n = Number(q);
//     return Number.isFinite(n) ? Math.max(0, round2(n)) : null;
//   };

//   const enforceAvailableQty = (line: any, attemptedQty?: number) => {
//     const availRaw = getAvailableQtyForLine(line);
//     const desired = Math.max(0, round2(attemptedQty ?? line.transactionQuantityIn ?? 0));

//     line._availableQty = availRaw;
//     line._qtyOver = false;
//     line._qtyOverMode = null;

//     if (availRaw == null) {
//       line.transactionQuantityIn = desired;
//       return true;
//     }

//     const available = Math.max(0, round2(availRaw));
//     line._availableQty = available;

//     const allowNeg = getNegativeSellingAllowedForLine(line);

//     if (desired > available) {
//       if (allowNeg) {
//         line.transactionQuantityIn = desired;
//         line._qtyOver = true;
//         line._qtyOverMode = 'WARN';
//         return true;
//       }

//       line.transactionQuantityIn = available;
//       line._qtyOver = true;
//       line._qtyOverMode = 'BLOCK';
//       return false;
//     }

//     line.transactionQuantityIn = desired;
//     return true;
//   };

//   // =========================
//   // linesKey (reload details only when itemId/uom changes)
//   // =========================
//   const linesKey = useMemo(() => {
//     const ls = values.materialTransactionsLineList || [];
//     return ls.map((l: any) => `${l?.transactionItemId || ''}:${l?.transactionUom || ''}`).join('|');
//   }, [values.materialTransactionsLineList]);

//   // =========================
//   // Update-mode: load missing details
//   // =========================
//   useEffect(() => {
//     const run = async () => {
//       if (!inventoryId) return;

//       const ls = values.materialTransactionsLineList || [];
//       const valid = ls.filter((l: any) => l?.transactionItemId && l?.transactionUom);
//       if (!valid.length) return;

//       const missingItemIds = new Set<string>();
//       for (const l of valid) {
//         const key = `${l.transactionItemId}|${l.transactionUom}`;
//         if (!detailsMap.has(key)) missingItemIds.add(String(l.transactionItemId));
//       }
//       if (!missingItemIds.size) return;

//       abortRef.current?.abort();
//       abortRef.current = new AbortController();

//       setDetailsLoading(true);
//       try {
//         const merged = new Map(detailsMap);

//         const params: any = {
//           InventoryId: inventoryId,
//           Scope: 1
//         };
//         if (subInventoryId) params.SubInventoryId = subInventoryId;
 
//         const ids = Array.from(missingItemIds);
//         for (const idsChunk of chunk(ids, 200)) {
//           const resp = await fetchItemsWithUomLookup(
//             params,
//             {
//               pageIndex: 1,
//               pageSize: 1500,
//               itemType: DEFAULT_ITEM_TYPE,
//               itemIds: idsChunk
//             } as any,
//             abortRef.current.signal
//           );

//           for (const r of resp.data?.data || []) {
//             merged.set(`${(r as any).itemId}|${(r as any).unitOfMeasure}`, r);
//           }
//         }

//         setDetailsMap(merged);
//       } catch (e: any) {
//         if (e?.name !== 'CanceledError') console.error(e);
//       } finally {
//         setDetailsLoading(false);
//       }
//     };

//     if (isUpdate === true) run();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [inventoryId, subInventoryId, linesKey, isUpdate]);

//   // clear details when context changes
//   useEffect(() => {
//     setDetailsMap(new Map());
//     loadedUomsRef.current.clear();
//   }, [inventoryId, subInventoryId]);

//   // =========================
//   // UOM options per item
//   // =========================
//   const uomsByItemId = useMemo(() => {
//     const map = new Map<string, ItemWithUomRow[]>();
//     for (const r of detailsMap.values()) {
//       const itemId = String((r as any)?.itemId ?? '');
//       if (!itemId) continue;
//       const list = map.get(itemId) ?? [];
//       list.push(r);
//       map.set(itemId, list);
//     }

//     for (const [itemId, list] of map.entries()) {
//       const uniq = new Map<string, ItemWithUomRow>();
//       for (const r of list) uniq.set(String((r as any).unitOfMeasure), r);
//       map.set(itemId, Array.from(uniq.values()));
//     }

//     return map;
//   }, [detailsMap]);

//   const loadedUomsRef = useRef(new Set<string>());
//   const uomsAbortRef = useRef<AbortController | null>(null);
//   const [uomsLoading, setUomsLoading] = useState(false);

//   const ensureItemUomsLoaded = async (itemId: string) => {
//     if (!inventoryId || !itemId) return;

//     const key = `${inventoryId}|${subInventoryId || ''} |${DEFAULT_ITEM_TYPE}|${itemId}`;
//     if (loadedUomsRef.current.has(key)) return;
//     loadedUomsRef.current.add(key);

//     try {
//       uomsAbortRef.current?.abort();
//       uomsAbortRef.current = new AbortController();
//       setUomsLoading(true);

//       const params: any = { InventoryId: inventoryId, Scope: 1 };
//       if (subInventoryId) params.SubInventoryId = subInventoryId;
 
//       const resp = await fetchItemsWithUomLookup(
//         params,
//         {
//           pageIndex: 1,
//           pageSize: 3000,
//           itemType: DEFAULT_ITEM_TYPE,
//           itemIds: [itemId]
//         } as any,
//         uomsAbortRef.current.signal
//       );

//       const list: ItemWithUomRow[] = resp?.data?.data || [];
//       if (!Array.isArray(list) || list.length === 0) return;

//       setDetailsMap(prev => {
//         const merged = new Map(prev);
//         for (const r of list) merged.set(`${(r as any).itemId}|${(r as any).unitOfMeasure}`, r);
//         return merged;
//       });
//     } catch (e: any) {
//       if (e?.name !== 'CanceledError') {
//         loadedUomsRef.current.delete(key);
//         console.error(e);
//       }
//     } finally {
//       setUomsLoading(false);
//     }
//   };

//   // =========================
//   // Barcode quick add
//   // =========================
//   const barcodeInputRef = useRef<HTMLInputElement | null>(null);
//   const barcodeAbortRef = useRef<AbortController | null>(null);
//   const [barcodeTerm, setBarcodeTerm] = useState('');
//   const [barcodeLoading, setBarcodeLoading] = useState(false);

//   const [barcodeMsg, setBarcodeMsg] = useState<string | null>(null);
//   const [barcodeMsgType, setBarcodeMsgType] = useState<'warn' | 'error' | null>(null);

//   useEffect(() => {
//     setBarcodeMsg(null);
//     setBarcodeMsgType(null);
//     if (!inventoryId) return;
//     const h = window.setTimeout(() => barcodeInputRef.current?.focus(), 50);
//     return () => window.clearTimeout(h);
//   }, [inventoryId, subInventoryId]);

//   const pickBestRowForBarcode = (rows: ItemWithUomRow[]) => {
//     if (!Array.isArray(rows) || rows.length === 0) return null;
//     return (rows as any).find((r: any) => r?.isPrimaryUOM) || rows[0];
//   };

//   const addLineByBarcode = async (rawBarcode: string) => {
//     const barcode = String(rawBarcode || '').trim();
//     if (!barcode) return;

//     setBarcodeMsg(null);
//     setBarcodeMsgType(null);

//     if (!inventoryId) {
//       setBarcodeMsg(i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.');
//       setBarcodeMsgType('error');
//       barcodeInputRef.current?.focus();
//       return;
//     }

//     if (isDisabled) return;

//     barcodeAbortRef.current?.abort();
//     barcodeAbortRef.current = new AbortController();

//     setBarcodeLoading(true);
//     try {
//       const params: any = { InventoryId: inventoryId, Scope: 1 };
//       if (subInventoryId) params.SubInventoryId = subInventoryId;
 
//       const resp = await fetchItemsWithUomLookup(
//         params,
//         {
//           pageIndex: 1,
//           pageSize: 30,
//           itemType: DEFAULT_ITEM_TYPE,
//           barcodeEqual: barcode
//         } as any,
//         barcodeAbortRef.current.signal
//       );

//       const list: ItemWithUomRow[] = resp?.data?.data || [];
//       const picked = pickBestRowForBarcode(list) as any;

//       if (!picked?.itemId || !picked?.unitOfMeasure) {
//         setBarcodeMsg(i18n.language === 'en' ? 'Barcode not found.' : 'لا يوجد صنف بهذا الباركود.');
//         setBarcodeMsgType('error');
//         barcodeInputRef.current?.focus();
//         return;
//       }

//       const allowNegPicked = picked?.authorizeNegativeStock === true;

//       setDetailsMap(prev => {
//         const m = new Map(prev);
//         m.set(`${picked.itemId}|${picked.unitOfMeasure}`, picked);
//         return m;
//       });

//       ensureItemUomsLoaded(String(picked.itemId));

//       const currentLines = [...(values.materialTransactionsLineList || [])];

//       const existingIndex = currentLines.findIndex(
//         (l: any) =>
//           String(l?.transactionItemId || '') === String(picked.itemId) &&
//           String(l?.transactionUom || '') === String(picked.unitOfMeasure)
//       );

//       if (existingIndex >= 0) {
//         const line = { ...currentLines[existingIndex] };
//         const desired = Number(line.transactionQuantityIn || 0) + 1;

//         line._authorizeNegativeStock = allowNegPicked;

//         const ok = enforceAvailableQty(line, desired);
//         if (!ok && !allowNegPicked) {
//           setBarcodeMsg(stockBlockText());
//           setBarcodeMsgType('error');
//           barcodeInputRef.current?.focus();
//           return;
//         }
//         if (line._qtyOverMode === 'WARN') {
//           setBarcodeMsg(stockWarnText());
//           setBarcodeMsgType('warn');
//         }

//         // ✅ إذا لا نعرض السعر => اجبره 0
//         if (!showUnitPrice) line.unitPrice = 0;

//         currentLines[existingIndex] = line;
//         formik.setFieldValue('materialTransactionsLineList', currentLines);
//       } else {
//         const newLine: any = {
//           id: null,
//           transactionItemId: picked.itemId,
//           transactionUom: picked.unitOfMeasure,

//           // ✅ السعر فقط يظهر لو methodTransfer=2 وإلا يبقى 0
//           unitPrice: 0,

//           transactionQuantityIn: 1,
//           transactionQuantityOut: 0,
//           lotId: null,

//           inventoryId: '',
//           discount: 0,
//           codeCombinationId: '',
//           currencyCode: '',
//           currencyConversionRate: 0,
//           referenceIdMaster: '',
//           referenceIdLine: '',
//           transactionTypeId: '',
//           equivalent: 0,
//           expensesAmount: 0,
//           batchId: '',

//           _availableQty: null,
//           _qtyOver: false,
//           _qtyOverMode: null,
//           _authorizeNegativeStock: allowNegPicked
//         };

//         const ok = enforceAvailableQty(newLine, newLine.transactionQuantityIn);
//         if (!ok && !allowNegPicked) {
//           setBarcodeMsg(stockBlockText());
//           setBarcodeMsgType('error');
//           barcodeInputRef.current?.focus();
//           return;
//         }
//         if (newLine._qtyOverMode === 'WARN') {
//           setBarcodeMsg(stockWarnText());
//           setBarcodeMsgType('warn');
//         }

//         formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
//       }

//       setBarcodeTerm('');
//       barcodeInputRef.current?.focus();
//     } catch (e: any) {
//       if (e?.name !== 'CanceledError') {
//         console.error(e);
//         setBarcodeMsg(i18n.language === 'en' ? 'Failed to lookup barcode.' : 'تعذر البحث عن الباركود.');
//         setBarcodeMsgType('error');
//       }
//     } finally {
//       setBarcodeLoading(false);
//     }
//   };

//   // =========================
//   // Line handlers
//   // =========================
//   const resetLine = (line: any) => ({
//     ...line,
//     transactionItemId: null,
//     transactionUom: '',
//     transactionQuantityIn: 0,
//     lotId: null,

//     // ✅
//     unitPrice: 0,

//     _availableQty: null,
//     _qtyOver: false,
//     _qtyOverMode: null,
//     _authorizeNegativeStock: null
//   });

//   const handleAddLine = () => {
//     const newLine: any = {
//       id: null,
//       transactionItemId: null,
//       transactionUom: '',

//       // ✅
//       unitPrice: 0,

//       transactionQuantityIn: 0,
//       transactionQuantityOut: 0,
//       lotId: null,

//       inventoryId: '',
//       discount: 0,
//       codeCombinationId: '',
//       currencyCode: '',
//       currencyConversionRate: 0,
//       referenceIdMaster: '',
//       referenceIdLine: '',
//       transactionTypeId: '',
//       equivalent: 0,
//       expensesAmount: 0,
//       batchId: '',

//       _availableQty: null,
//       _qtyOver: false,
//       _qtyOverMode: null,
//       _authorizeNegativeStock: null
//     };

//     const currentLines = values.materialTransactionsLineList || [];
//     formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = (values.materialTransactionsLineList || []).filter((_: any, i: number) => i !== index);
//     formik.setFieldValue('materialTransactionsLineList', updatedLines);
//   };

//   const handleLineChange = (index: number, field: string, value: any) => {
//     const updated = [...(values.materialTransactionsLineList || [])];
//     if (!updated[index]) return;

//     const line = { ...updated[index] };

//     if (field === 'clearItem') {
//       updated[index] = resetLine(line);
//       formik.setFieldValue('materialTransactionsLineList', updated);
//       return;
//     }

//     // ✅ ممنوع تعديل السعر إذا ما نعرضه
//     if (field === 'unitPrice' && !showUnitPrice) return;

//     if (field === 'transactionUom') {
//       if (line.transactionItemId && lineHasDuplicateItemUom(line.transactionItemId, value, index)) {
//         ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
//         return;
//       }

//       const next = { ...line, transactionUom: value };

//       const ok = enforceAvailableQty(next, next.transactionQuantityIn);

//       if (!ok && !getNegativeSellingAllowedForLine(next)) {
//         ToastSwal({ position: 'bottom-start', text: stockBlockText() });
//       } else if (next._qtyOverMode === 'WARN') {
//         ToastSwal({ position: 'bottom-start', text: stockWarnText() });
//       }

//       // ✅ إذا لا نعرض السعر اجبره 0
//       if (!showUnitPrice) next.unitPrice = 0;

//       updated[index] = next;
//       formik.setFieldValue('materialTransactionsLineList', updated);
//       return;
//     }

//     if (field === 'transactionQuantityIn') {
//       const next = { ...line, transactionQuantityIn: value };

//       const ok = enforceAvailableQty(next, value);

//       if (!ok && !getNegativeSellingAllowedForLine(next)) {
//         ToastSwal({ position: 'bottom-start', text: stockBlockText() });
//       } else if (next._qtyOverMode === 'WARN') {
//         ToastSwal({ position: 'bottom-start', text: stockWarnText() });
//       }

//       if (!showUnitPrice) next.unitPrice = 0;

//       updated[index] = next;
//       formik.setFieldValue('materialTransactionsLineList', updated);
//       return;
//     }

//     updated[index] = { ...line, [field]: value };

//     // ✅ safety
//     if (!showUnitPrice) updated[index].unitPrice = 0;

//     formik.setFieldValue('materialTransactionsLineList', updated);
//   };

//   // =========================
//   // Open picker for line
//   // =========================
//   const openPickerForLine = async (lineIndex: number) => {
//     const ls = values.materialTransactionsLineList || [];
//     const line = ls[lineIndex];
//     if (!line) return;

//     if (!inventoryId) {
//       ToastSwal({
//         position: 'bottom-start',
//         text: i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.'
//       });
//       return;
//     }

//     if (isDisabled) return;

//     const params: any = {
//       InventoryId: inventoryId,
//       Scope: 1
//     };
//     if (subInventoryId) params.SubInventoryId = subInventoryId;
 
     
//     const picked = await pickItemUom({
//       title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار الصنف',
//       params,
//       bodyDefaults: { itemType: DEFAULT_ITEM_TYPE },
//       pageSize: 10,
//       searchMode: 'manual',
//       initialSearchField: 'barcodeEqual',
//       isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex),
//       dynamicFields: ['quentity', 'barcode']
//     });

//     if (!picked) return;

//     const row: any = picked.row;
//     if (!row?.itemId || !row?.unitOfMeasure) return;

//     if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
//       ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
//       return;
//     }

//     const allowNeg = row?.authorizeNegativeStock === true;
//     const rowAvail = Number(row?.quentity);
//     const hasRowAvail = Number.isFinite(rowAvail);

//     const currentQty = Number(line?.transactionQuantityIn || 0);
//     if (hasRowAvail && currentQty > rowAvail && !allowNeg) {
//       ToastSwal({ position: 'bottom-start', text: stockBlockText() });
//       return;
//     }
//     if (hasRowAvail && currentQty > rowAvail && allowNeg) {
//       ToastSwal({ position: 'bottom-start', text: stockWarnText() });
//     }

//     setDetailsMap(prev => {
//       const m = new Map(prev);
//       m.set(`${row.itemId}|${row.unitOfMeasure}`, row);
//       return m;
//     });

//     const updated = [...ls];
//     const currentLine = { ...updated[lineIndex] };

//     updated[lineIndex] = {
//       ...currentLine,
//       transactionItemId: row.itemId,
//       transactionUom: row.unitOfMeasure,
//       _authorizeNegativeStock: allowNeg,
//       // ✅ إذا لا نعرض السعر اجبره 0
//       unitPrice: showUnitPrice ? Number(currentLine.unitPrice || 0) : 0
//     };

//     const ok = enforceAvailableQty(updated[lineIndex], Number(updated[lineIndex].transactionQuantityIn || 0));

//     if (!ok && !getNegativeSellingAllowedForLine(updated[lineIndex])) {
//       ToastSwal({ position: 'bottom-start', text: stockBlockText() });
//     } else if (updated[lineIndex]._qtyOverMode === 'WARN') {
//       ToastSwal({ position: 'bottom-start', text: stockWarnText() });
//     }

//     formik.setFieldValue('materialTransactionsLineList', updated);

//     ensureItemUomsLoaded(String(row.itemId));
//   };

//   // =========================
//   // Reference fetch (keep your old logic)
//   // =========================
//   const { itemsList, loading: loading1 } = useAppSelector(state => state.Inv);

//   const updateFieldsBasedOnCode = (data: any) => {
//     setFieldValue('referenceCode', data?.data?.code);

//     switch (values.code) {
//       case 'INV':
//         setFieldValue('customerId', data?.data?.peopleId ?? null);
//         setFieldValue('inventoryId', data?.data?.inventoryId);
//         break;
//       case 'SOI':
//         setFieldValue('customerId', data?.data?.peopleId ?? null);
//         setFieldValue('supplierId', null);
//         break;
//       case 'IOI':
//         setFieldValue('subInventoryId', data?.data?.subInventoryId);
//         setFieldValue('inventoryId', data?.data?.inventoryId);
//         break;
//       case 'SPR':
//         setFieldValue('supplierId', data?.data?.peopleId ?? null);
//         setFieldValue('customerId', null);
//         break;
//       case 'BIL':
//         setFieldValue('supplierId', data?.data?.peopleId);
//         setFieldValue('customerId', null);
//         break;
//       case 'CRT':
//         setFieldValue('supplierId', null);
//         setFieldValue('customerId', data?.data?.peopleId);
//         break;
//       case 'IOR':
//         setFieldValue('branchId', data?.data?.branchId);
//         break;
//       default:
//         break;
//     }
//   };

//   useEffect(() => {
//     if (['MII', 'MIR'].includes(values.code)) return;

//     if (values.referenceId) {
//       dispatch(fetchDataByReferenceId({ referenceId: values.referenceId, code: values.code }))
//         .unwrap()
//         .then(({ data }) => updateFieldsBasedOnCode(data))
//         .catch(error => console.error('Failed to fetch data:', error));
//     }

//     return () => {
//       dispatch(cleanUpItemsList());
//     };
//   }, [values.referenceId, values.code]);

//   useEffect(() => {
//     if (isUpdate === false) {
//       // ✅ إذا methodTransfer !=2 لا تسمح بأسعار قادمة من itemsList (احتياط)
//       const list = (itemsList || []).map((x: any) => ({
//         ...x,
//         unitPrice: showUnitPrice ? Number(x?.unitPrice || 0) : 0
//       }));
//       formik.setFieldValue('materialTransactionsLineList', list);
//     } else {
//       const list = (values.materialTransactionsLineList || []).map((m: any) => {
//         const targetItem: any = (itemsList || []).find((f: any) => f.transactionItemId === m.transactionItemId);
//         return {
//           ...m,
//           unitPrice: showUnitPrice ? Number(m?.unitPrice || 0) : 0,
//           RealQty: targetItem?.RealQty,
//           RemainingQty: Number(m?.transactionQuantityIn) + Number(targetItem?.RemainingQty),
//           dispensedQuantity: Number(targetItem?.dispensedQuantity) - Number(m?.transactionQuantityIn)
//         };
//       });
//       formik.setFieldValue('materialTransactionsLineList', list);
//     }
//   }, [itemsList]);

//   // =========================
//   // UI
//   // =========================
//   const Lines: any[] = values.materialTransactionsLineList?.slice() || [];

//   return (
//     <>
//       <Loading loading={loading1} Type='Dots'>
//         <ItemUomPickerModal {...modalProps} />

//         <div className='mb-3'>
//           <div className='row mb-2'>
//             <div className='col-lg-9'>
//               <div className='position-relative' style={{ maxWidth: 420 }}>
//                 <div className='input-group input-group-sm'>
//                   <span className='input-group-text'>
//                     <i className='fas fa-barcode text-muted'></i>
//                   </span>

//                   <input
//                     ref={barcodeInputRef}
//                     value={barcodeTerm}
//                     onChange={e => {
//                       setBarcodeTerm(e.target.value);
//                       if (barcodeMsg) {
//                         setBarcodeMsg(null);
//                         setBarcodeMsgType(null);
//                       }
//                     }}
//                     onKeyDown={e => {
//                       if (e.key === 'Enter') {
//                         e.preventDefault();
//                         addLineByBarcode(barcodeTerm);
//                       }
//                       if (e.key === 'Escape') {
//                         setBarcodeTerm('');
//                         setBarcodeMsg(null);
//                         setBarcodeMsgType(null);
//                       }
//                     }}
//                     className='form-control'
//                     disabled={!inventoryId || barcodeLoading || isDisabled}
//                     placeholder={t('امسح الباركود أو أدخل الرقم')}
//                     inputMode='numeric'
//                   />

//                   {barcodeLoading ? (
//                     <span className='input-group-text'>
//                       <span className='spinner-border spinner-border-sm text-theme' />
//                     </span>
//                   ) : (
//                     <button
//                       className='input-group-text'
//                       onClick={() => barcodeTerm && addLineByBarcode(barcodeTerm)}
//                       disabled={!barcodeTerm || barcodeLoading || !inventoryId || isDisabled}
//                       title={t('إضافة')}
//                     >
//                       <i className='fas fa-plus text-theme'></i>
//                     </button>
//                   )}
//                 </div>

//                 {barcodeMsg && (
//                   <div className='position-absolute top-100 start-0 mt-1 w-100' style={{ zIndex: 1025 }}>
//                     <div
//                       className={`alert alert-sm py-1 mb-0 d-flex align-items-center ${
//                         barcodeMsgType === 'warn' ? 'alert-warning' : 'alert-danger'
//                       }`}
//                     >
//                       <i
//                         className={`fas me-2 ${
//                           barcodeMsgType === 'warn' ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'
//                         }`}
//                       ></i>
//                       <small>{barcodeMsg}</small>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {detailsLoading && isUpdate && (
//                 <div className='mt-2 text-muted small'>
//                   <span className='spinner-border spinner-border-sm text-theme me-2'></span>
//                   {t('جاري تحميل التفاصيل...')}
//                 </div>
//               )}
//             </div>

//             <div className='col-lg-3 text-end'>
//               {!isDisabled && (
//                 <button type='button' className='btn btn-theme' onClick={handleAddLine}>
//                   {t('إضافة صنف')}
//                 </button>
//               )}
//             </div>
//           </div>

//           <div
//             className={`table-responsive rounded-2 text-center ${
//               formik.errors.materialTransactionsLineList ? 'border-bottom border-2 border-danger' : ''
//             }`}
//           >
//             <table className='table table-borderless table-hover mb-0'>
//               <thead className='bg-theme bg-opacity-30'>
//                 <tr>
  
//                   <th className='align-middle' style={{ width: '48%' }}>
//                     {t('اسم الصنف')}
//                   </th>
//                   <th className='align-middle' style={{ width: '15%' }}>
//                     {t('الوحدة')}
//                   </th>
//                   <th className='align-middle' style={{ width: '15%' }}>
//                     {t('رقم التشغيل')}
//                   </th>

//                   {/* ✅ السعر يظهر فقط إذا methodTransfer=2 */}
//                   {showUnitPrice && (
//                     <th className='align-middle' style={{ width: '10%' }}>
//                       {t('السعر')}
//                     </th>
//                   )}

//                   <th className='align-middle' style={{ width: '8%' }}>
//                     {t('الكمية')}
//                   </th>

//                   <th className='align-middle text-end' style={{ width: '3%' }}></th>
//                 </tr>
//               </thead>

//               <tbody className='fw-bold'>
//                 {[...Lines].reverse().map((line: any, revIndex: number) => {
//                   const Index = Lines.length - 1 - revIndex;

//                   const info = getInfo(line) as any;
//                   const itemName = line.transactionItemId ? getItemNameForLine(line) : '';
//                   const uomName = line.transactionItemId ? getUomNameForLine(line) : '';
//                   const barcode = line.transactionItemId ? getBarcodeForLine(line) : '';

//                   const uomOptions = line.transactionItemId ? uomsByItemId.get(String(line.transactionItemId)) || [] : [];

//                   const isDuplicate =
//                     line.transactionItemId &&
//                     line.transactionUom &&
//                     (values.materialTransactionsLineList || []).some(
//                       (l: any, i: number) =>
//                         i !== Index &&
//                         String(l?.transactionItemId || '') === String(line.transactionItemId) &&
//                         String(l?.transactionUom || '') === String(line.transactionUom || '')
//                     );

//                   const availableQty = getAvailableQtyForLine(line);
//                   const hasAvail = availableQty != null;

//                   const allowNegLine = getNegativeSellingAllowedForLine(line);
//                   const qtyOver = Boolean(line?._qtyOver);
//                   const isBlock = qtyOver && String(line?._qtyOverMode || '') === 'BLOCK';
//                   const overText = allowNegLine ? stockWarnText() : stockBlockText();

//                   const lots: any[] = Array.isArray(info?.qtyByLot) ? info.qtyByLot : [];
//                   const sumLots = lots.reduce((s: number, x: any) => s + Number(x?.qty || 0), 0);

//                   return (
//                     <tr key={Index}>
               

//                       <td className='align-middle small'>
//                         <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
//                           <div className='d-flex align-items-start gap-2'>
//                             <div className='flex-grow-1' style={{ minWidth: 0 }}>
//                               {line.transactionItemId ? (
//                                 <>
//                                   <span className='fw-bold text-truncate d-block'>
//                                     {itemName ||
//                                       (detailsLoading
//                                         ? i18n.language === 'en'
//                                           ? 'Loading...'
//                                           : '...جاري التحميل'
//                                         : `ID: ${line.transactionItemId}`)}
//                                   </span>

//                                   <small className='text-muted d-block'>
//                                     {t('الوحدة')}:{' '}
//                                     <span className='fw-bold text-theme'>{uomName || line.transactionUom || '-'}</span>
//                                     <span className='mx-2'>•</span>
//                                     {t('باركود')}: <span className='fw-bold'>{barcode || '-'}</span>
//                                   </small>
//                                 </>
//                               ) : (
//                                 <span className='text-muted'>{t('اختر الصنف')}</span>
//                               )}

//                               {isDuplicate && (
//                                 <small className='text-danger d-block mt-1'>
//                                   <i className='fas fa-exclamation-triangle me-1'></i>
//                                   {t('هذا الصنف مكرر مع نفس الوحدة')}
//                                 </small>
//                               )}
//                             </div>

//                             <div className='d-flex gap-1'>
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-theme rounded-0'
//                                 onClick={() => openPickerForLine(Index)}
//                                 disabled={!inventoryId || isDisabled}
//                                 title={!inventoryId ? t('يجب اختيار المخزن أولاً.') : t('اختيار صنف ووحدة')}
//                               >
//                                 <i className='fas fa-search me-1'></i>
//                                 {line.transactionItemId ? t('تغيير') : t('اختيار')}
//                               </button>

//                               {line.transactionItemId && (
//                                 <button
//                                   type='button'
//                                   className='btn btn-sm btn-outline-danger rounded-0'
//                                   onClick={() => handleLineChange(Index, 'clearItem', true)}
//                                   title={t('مسح الصنف')}
//                                   disabled={isDisabled}
//                                 >
//                                   <i className='fas fa-times'></i>
//                                 </button>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </td>

//                       <td className='align-middle small'>
//                         <select
//                           disabled={!line.transactionItemId || isDisabled}
//                           className={`form-select text-center ${isDuplicate ? 'border-danger' : 'border-theme'}`}
//                           value={line.transactionUom || ''}
//                           onFocus={() => {
//                             if (line.transactionItemId) ensureItemUomsLoaded(String(line.transactionItemId));
//                           }}
//                           onChange={e => handleLineChange(Index, 'transactionUom', e.target.value)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                           {line.transactionUom && uomOptions.length === 0 && (
//                             <option value={line.transactionUom}>{uomName || line.transactionUom}</option>
//                           )}

//                           {uomOptions.map((u: any) => {
//                             const isEn = i18n.language === 'en';
//                             const label =
//                               (isEn
//                                 ? u?.unitOfMeasureName || u?.unitOfMeasureName2
//                                 : u?.unitOfMeasureName2 || u?.unitOfMeasureName) || `ID: ${u?.unitOfMeasure}`;

//                             return (
//                               <option key={String(u?.unitOfMeasure)} value={String(u?.unitOfMeasure)}>
//                                 {label}
//                               </option>
//                             );
//                           })}

//                           {uomsLoading && line.transactionItemId ? (
//                             <option value={line.transactionUom || ''} disabled>
//                               {i18n.language === 'en' ? 'Loading...' : '...جاري التحميل'}
//                             </option>
//                           ) : null}
//                         </select>
//                       </td>

//                       <td className='align-middle small'>
//                         <PopoverCustom
//                           childern={
//                             <select
//                               className='form-select text-center'
//                               value={line.lotId || ''}
//                               onChange={e => handleLineChange(Index, 'lotId', e.target.value)}
//                               disabled={!line.transactionItemId || !line.transactionUom || isDisabled}
//                             >
//                               <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                               {lots
//                                 ?.filter((x: any) => x?.lotId)
//                                 ?.map((x: any) => (
//                                   <option key={x.lotId} value={x.lotId || ''}>
//                                     {x.lotNumber || x.lotId}
//                                   </option>
//                                 ))}
//                             </select>
//                           }
//                           Header='تفاصيل الصنف'
//                           Body={
//                             <>
//                               <div className='d-flex justify-content-between'>
//                                 <span className='mt-1'>{t('المتوفر')}</span>
//                                 <span className='text-theme fw-bold fs-6 mx-2'>
//                                   {hasAvail ? formatNumber(Number(availableQty || 0)) : formatNumber(Number(sumLots || 0))}
//                                 </span>
//                               </div>

//                               {line.lotId && lots?.length > 0 ? (
//                                 <>
//                                   <div className='d-flex justify-content-between'>
//                                     <span className='mt-1'>{t('الكمية')}</span>
//                                     <span className='text-theme fw-bold fs-6 mx-2'>
//                                       {formatNumber(
//                                         Number(lots.find((x: any) => String(x?.lotId) === String(line.lotId))?.qty || 0)
//                                       )}
//                                     </span>
//                                   </div>

//                                   <div className='d-flex justify-content-between'>
//                                     <span className='mt-1'>{t('تاريخ الإنتهاء')}</span>
//                                     <span className='text-theme fw-bold fs-6 mx-2'>
//                                       {String(
//                                         lots.find((x: any) => String(x?.lotId) === String(line.lotId))?.expirationDate || ''
//                                       )
//                                         ?.toString()
//                                         ?.split('T')[0] || '-'}
//                                     </span>
//                                   </div>
//                                 </>
//                               ) : null}
//                             </>
//                           }
//                         />
//                       </td>

//                       {/* ✅ السعر يظهر فقط إذا methodTransfer=2 */}
//                       {showUnitPrice && (
//                         <td className='align-middle small'>
//                           <NumericFormat
//                             value={Number(line.unitPrice || 0)}
//                             thousandSeparator=','
//                             decimalSeparator='.'
//                             decimalScale={2}
//                             allowNegative={false}
//                             className='form-control text-center px-0 bg-body border-theme'
//                             disabled={!line.transactionItemId || isDisabled}
//                             onValueChange={v => handleLineChange(Index, 'unitPrice', v.floatValue ?? 0)}
//                           />
//                         </td>
//                       )}

//                       <td className='align-middle small'>
//                         <div style={{ width: '100%' }}>
//                           <NumericFormat
//                             value={line.transactionQuantityIn}
//                             thousandSeparator=','
//                             decimalSeparator='.'
//                             decimalScale={0}
//                             allowNegative={false}
//                             className={`form-control text-center px-0 bg-body ${
//                               isBlock ? 'border-danger' : qtyOver ? 'border-warning' : 'border-theme'
//                             }`}
//                             disabled={!line.transactionItemId || isDisabled}
//                             onValueChange={v => handleLineChange(Index, 'transactionQuantityIn', v.floatValue ?? 0)}
//                           />

//                           {hasAvail && (
//                             <small className='d-block mt-1 text-muted'>
//                               {i18n.language === 'en' ? 'Available:' : 'المتوفر:'}{' '}
//                               <span className='fw-bold'>{formatNumber(Number(availableQty || 0))}</span>
//                             </small>
//                           )}

//                           {qtyOver && (
//                             <small className={`${isBlock ? 'text-danger' : 'text-warning'} d-block mt-1`}>
//                               <i className='fas fa-exclamation-triangle me-1'></i>
//                               {overText}
//                             </small>
//                           )}
//                         </div>
//                       </td>

//                       <td className='align-middle small'>
//                         <button
//                           type='button'
//                           className='btn btn-outline-danger'
//                           onClick={() => handleDeleteLine(Index)}
//                           disabled={isDisabled}
//                         >
//                           <i className='fas fa-trash-alt'></i>
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}

//                 {Lines.length === 0 ? (
//                   <tr>
//                     <td colSpan={showUnitPrice ? 7 : 6} className='text-center py-4 text-muted'>
//                       {t('لا توجد بنود')}
//                       {!isDisabled && (
//                         <div className='mt-2'>
//                           <button type='button' className='btn btn-theme' onClick={handleAddLine}>
//                             <i className='fas fa-plus me-2'></i>
//                             {t('إضافة أول بند')}
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>

//             {formik.errors.materialTransactionsLineList?.length ? <div className='text-danger'> * مطلوب </div> : null}
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default MoveLines;


// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { type FormikProps } from 'formik';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
//  import ToastSwal from '@components/Shared/Alert/ToastSwal';
// import { NumericFormat } from 'react-number-format';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { cleanUpItemsList, fetchDataByReferenceId } from '@store/INV/Transactions/InvIssue/invSlice';

// // ✅ Picker
// import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// // ✅ API
// import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import NeatixModal from '@components/Modal/NeatixModal';

// interface LinesProps {
//   formik: FormikProps<any>;
//   isUpdate?: boolean;
//   isPosted?: boolean;
//   canAddLine?: boolean;
//   canDeleteLine?: boolean;
//   canPickItem?: boolean;
//   canEditQty?: boolean;
//   canChangeUom?: boolean;
// }

// type ItemType = 'InventoryItem';
// const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

// const n = (value: any) => Number(value || 0);

// const MoveLines: React.FC<LinesProps> = ({ 
//   formik, 
//   isUpdate = false,
//   isPosted = false,
//   canAddLine = true,
//   canDeleteLine = true,
//   canPickItem = true,
//   canEditQty = true,
//   canChangeUom = true
// }) => {
//   const { values, setFieldValue } = formik;
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();

//   // ✅ Picker
//   const { pickItemUom, modalProps } = useItemUomPicker();

//   // =========================
//   // Context
//   // =========================
//   const inventoryId: string | null = values?.inventoryId ?? null;
//   const subInventoryId: string | null = values?.subInventoryId ?? null;

//   // ✅ pricing rule:
//   // 1 => no price column
//   // 2 => show price column (user input)
//   const methodTransfer = Number(values?.methodTransfer ?? 0);
//   const showUnitPrice = methodTransfer === 2;

//   const IsEnabledByCode = () => {
//     return ['SPR', 'WOI', 'IOI', 'CCA', 'SOI', 'INV', 'MOI', 'MOR', 'IOR', 'BIL', 'POR', 'PIA', 'CRT'].includes(
//       values.code
//     );
//   };
//   const isDisabled = IsEnabledByCode();

//   // =========================
//   // ✅ Details map (ItemId|UOM -> row)
//   // =========================
//   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const abortRef = useRef<AbortController | null>(null);

//   const getInfoExact = (line: any) => {
//     if (!line?.transactionItemId || !line?.transactionUom) return null;
//     return detailsMap.get(`${line.transactionItemId}|${line.transactionUom}`) || null;
//   };

//   const getInfoAnyByItemId = (itemId: string) => {
//     if (!itemId) return null;
//     for (const [key, value] of detailsMap.entries()) {
//       if (key.startsWith(`${itemId}|`)) return value;
//     }
//     return null;
//   };

//   const getItemNameForLine = (line: any) => {
//     const info = getInfoExact(line) as any || getInfoAnyByItemId(line?.transactionItemId);
//     const isEn = i18n.language === 'en';
//     const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
//     return name || '';
//   };

//   const getUomNameForLine = (line: any) => {
//     const info = getInfoExact(line) as any || getInfoAnyByItemId(line?.transactionItemId);
//     const isEn = i18n.language === 'en';
//     const uomName = isEn
//       ? info?.unitOfMeasureName || info?.unitOfMeasureName2
//       : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
//     return uomName || '';
//   };

//   const getBarcodeForLine = (line: any) => {
//     const info = getInfoExact(line) as any || getInfoAnyByItemId(line?.transactionItemId);
//     return info?.barcode || '';
//   };

//   // =========================
//   // Lot Handling
//   // =========================
//   const [lotPickerOpen, setLotPickerOpen] = useState(false);
//   const [lotPickerLineIndex, setLotPickerLineIndex] = useState<number | null>(null);
//   const [lotPickerItemTitle, setLotPickerItemTitle] = useState('');
//   const [lotPickerLotRows, setLotPickerLotRows] = useState<any[]>([]);
//   const [lotPickerSelectedLotId, setLotPickerSelectedLotId] = useState<string | null>(null);
//   const [lotSearch, setLotSearch] = useState('');

//   const openLotPicker = (lineIndex: number, lotRows: any[], currentLotId: string | null, itemTitle: string) => {
//     setLotPickerLineIndex(lineIndex);
//     setLotPickerItemTitle(itemTitle);
//     setLotPickerLotRows(lotRows);
//     setLotPickerSelectedLotId(currentLotId);
//     setLotSearch('');
//     setLotPickerOpen(true);
//   };

//   const closeLotPicker = () => {
//     setLotPickerOpen(false);
//     setLotPickerLineIndex(null);
//     setLotPickerLotRows([]);
//     setLotPickerItemTitle('');
//     setLotPickerSelectedLotId(null);
//     setLotSearch('');
//   };

//   const chooseLot = (lotId: string | null) => {
//     if (lotPickerLineIndex === null) return;

//     const updated = [...(values.materialTransactionsLineList || [])];
//     updated[lotPickerLineIndex] = { ...updated[lotPickerLineIndex], lotId };
//     formik.setFieldValue('materialTransactionsLineList', updated);
    
//     closeLotPicker();
//   };

//   const filteredLotRows = useMemo(() => {
//     if (!lotSearch.trim()) return lotPickerLotRows;
//     return lotPickerLotRows.filter((r: any) => {
//       const lotNumber = r?.lotNumber || '';
//       return lotNumber.toLowerCase().includes(lotSearch.toLowerCase());
//     });
//   }, [lotPickerLotRows, lotSearch]);

//   // =========================
//   // Duplicate rules (item+uom)
//   // =========================
//   const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
//     if (!itemId || !uom) return false;
//     return (values.materialTransactionsLineList || []).some((l: any, i: number) => {
//       if (i === excludeIndex) return false;
//       return String(l?.transactionItemId || '') === String(itemId) && String(l?.transactionUom || '') === String(uom);
//     });
//   };

//   // =========================
//   // authorizeNegativeStock
//   // =========================
//   const stockWarnText = () =>
//     i18n.language === 'en'
//       ? 'Quantity exceeds available stock (negative selling allowed).'
//       : 'الكمية أكبر من المتوفر (مسموح السالب).';

//   const stockBlockText = () =>
//     i18n.language === 'en' ? 'Quantity exceeds available stock.' : 'الكمية المطلوبة أكبر من المتوفر.';

//   const getNegativeSellingAllowedForLine = (line: any) => {
//     const info = getInfoExact(line) as any;
//     const v = info?.authorizeNegativeStock ?? line?._authorizeNegativeStock;
//     return v === true;
//   };

//   const getAvailableQtyForLine = (line: any): number => {
//     const info = getInfoExact(line) as any || getInfoAnyByItemId(line?.transactionItemId);
//     const q = info?.quentity;
//     if (q == null || q === '') return 0;
//     const n = Number(q);
//     return Number.isFinite(n) ? Math.max(0, n) : 0;
//   };

//   const getMaxAllowedQty = (line: any) => {
//     const availableQty = getAvailableQtyForLine(line);
//     const allowNeg = getNegativeSellingAllowedForLine(line);
//     return allowNeg ? Infinity : availableQty;
//   };

//   // =========================
//   // linesKey (reload details only when itemId/uom changes)
//   // =========================
//   const linesKey = useMemo(() => {
//     const ls = values.materialTransactionsLineList || [];
//     return ls.map((l: any) => `${l?.transactionItemId || ''}:${l?.transactionUom || ''}`).join('|');
//   }, [values.materialTransactionsLineList]);

//   // =========================
//   // Update-mode: load missing details
//   // =========================
//   useEffect(() => {
//     const run = async () => {
//       if (!inventoryId) return;

//       const ls = values.materialTransactionsLineList || [];
//       const valid = ls.filter((l: any) => l?.transactionItemId && l?.transactionUom);
//       if (!valid.length) return;

//       const missing = valid.filter((l: any) => {
//         const key = `${l.transactionItemId}|${l.transactionUom}`;
//         return !detailsMap.has(key);
//       });
      
//       if (!missing.length) return;

//       abortRef.current?.abort();
//       abortRef.current = new AbortController();

//       setDetailsLoading(true);
//       try {
//         const merged = new Map(detailsMap);

//         const params: any = {
//           InventoryId: inventoryId,
//           Scope: 1
//         };
//         if (subInventoryId) params.SubInventoryId = subInventoryId;

//         const resp = await fetchItemsWithUomLookup(
//           params,
//           {
//             pageIndex: 1,
//             pageSize: 1500,
//             itemType: DEFAULT_ITEM_TYPE,
//             itemIds: missing.map((l: any) => l.transactionItemId)
//           } as any,
//           abortRef.current.signal
//         );

//         for (const r of resp.data?.data || []) {
//           merged.set(`${(r as any).itemId}|${(r as any).unitOfMeasure}`, r);
//         }

//         setDetailsMap(merged);
//       } catch (e: any) {
//         if (e?.name !== 'CanceledError') console.error(e);
//       } finally {
//         setDetailsLoading(false);
//       }
//     };

//     if (isUpdate === true) run();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [inventoryId, subInventoryId, linesKey, isUpdate]);

//   // clear details when context changes
//   useEffect(() => {
//     setDetailsMap(new Map());
//     loadedUomsRef.current.clear();
//   }, [inventoryId, subInventoryId]);

//   // =========================
//   // UOM options per item
//   // =========================
//   const uomsByItemId = useMemo(() => {
//     const map = new Map<string, ItemWithUomRow[]>();
//     for (const r of detailsMap.values()) {
//       const itemId = String((r as any)?.itemId ?? '');
//       if (!itemId) continue;
//       const list = map.get(itemId) ?? [];
//       list.push(r);
//       map.set(itemId, list);
//     }

//     for (const [itemId, list] of map.entries()) {
//       const uniq = new Map<string, ItemWithUomRow>();
//       for (const r of list) uniq.set(String((r as any).unitOfMeasure), r);
//       map.set(itemId, Array.from(uniq.values()));
//     }

//     return map;
//   }, [detailsMap]);

//   const loadedUomsRef = useRef(new Set<string>());
//   const uomsAbortRef = useRef<AbortController | null>(null);
//   const [uomsLoading, setUomsLoading] = useState(false);

//   const ensureItemUomsLoaded = async (itemId: string) => {
//     if (!inventoryId || !itemId) return;

//     const key = `${inventoryId}|${subInventoryId || ''} |${DEFAULT_ITEM_TYPE}|${itemId}`;
//     if (loadedUomsRef.current.has(key)) return;
//     loadedUomsRef.current.add(key);

//     try {
//       uomsAbortRef.current?.abort();
//       uomsAbortRef.current = new AbortController();
//       setUomsLoading(true);

//       const params: any = { InventoryId: inventoryId, Scope: 1 };
//       if (subInventoryId) params.SubInventoryId = subInventoryId;

//       const resp = await fetchItemsWithUomLookup(
//         params,
//         {
//           pageIndex: 1,
//           pageSize: 3000,
//           itemType: DEFAULT_ITEM_TYPE,
//           itemIds: [itemId]
//         } as any,
//         uomsAbortRef.current.signal
//       );

//       const list: ItemWithUomRow[] = resp?.data?.data || [];
//       if (!Array.isArray(list) || list.length === 0) return;

//       setDetailsMap(prev => {
//         const merged = new Map(prev);
//         for (const r of list) merged.set(`${(r as any).itemId}|${(r as any).unitOfMeasure}`, r);
//         return merged;
//       });
//     } catch (e: any) {
//       if (e?.name !== 'CanceledError') {
//         loadedUomsRef.current.delete(key);
//         console.error(e);
//       }
//     } finally {
//       setUomsLoading(false);
//     }
//   };

//   // =========================
//   // Line handlers
//   // =========================
//   const resetLine = (line: any) => ({
//     ...line,
//     transactionItemId: null,
//     transactionUom: '',
//     transactionQuantityIn: 0,
//     lotId: null,
//     unitPrice: 0,
//     _availableQty: null,
//     _qtyOver: false,
//     _qtyOverMode: null,
//     _authorizeNegativeStock: null
//   });

//   const handleAddLine = () => {
//     const newLine: any = {
//       id: null,
//       transactionItemId: null,
//       transactionUom: '',
//       unitPrice: 0,
//       transactionQuantityIn: 0,
//       transactionQuantityOut: 0,
//       lotId: null,
//       inventoryId: '',
//       discount: 0,
//       codeCombinationId: '',
//       currencyCode: '',
//       currencyConversionRate: 0,
//       referenceIdMaster: '',
//       referenceIdLine: '',
//       transactionTypeId: '',
//       equivalent: 0,
//       expensesAmount: 0,
//       batchId: '',
//       _availableQty: null,
//       _qtyOver: false,
//       _qtyOverMode: null,
//       _authorizeNegativeStock: null
//     };

//     const currentLines = values.materialTransactionsLineList || [];
//     formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
//   };

//   const handleDeleteLine = (index: number) => {
//     const updatedLines = (values.materialTransactionsLineList || []).filter((_: any, i: number) => i !== index);
//     formik.setFieldValue('materialTransactionsLineList', updatedLines);
//   };

//   const handleLineChange = (index: number, field: string, value: any) => {
//     const updated = [...(values.materialTransactionsLineList || [])];
//     if (!updated[index]) return;

//     const line = { ...updated[index] };

//     if (field === 'clearItem') {
//       updated[index] = resetLine(line);
//       formik.setFieldValue('materialTransactionsLineList', updated);
//       return;
//     }

//     // ✅ ممنوع تعديل السعر إذا ما نعرضه
//     if (field === 'unitPrice' && !showUnitPrice) return;

//     if (field === 'transactionUom') {
//       if (line.transactionItemId && lineHasDuplicateItemUom(line.transactionItemId, value, index)) {
//         ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
//         return;
//       }

//       const next = { ...line, transactionUom: value };
//       // ✅ إذا لا نعرض السعر اجبره 0
//       if (!showUnitPrice) next.unitPrice = 0;

//       updated[index] = next;
//       formik.setFieldValue('materialTransactionsLineList', updated);
//       return;
//     }

//     if (field === 'transactionQuantityIn') {
//       const maxAllowed = getMaxAllowedQty(line);
//       const allowNeg = getNegativeSellingAllowedForLine(line);
      
//       let finalValue = Number(value);
      
//       if (!allowNeg && finalValue > maxAllowed) {
//         finalValue = maxAllowed;
//         ToastSwal({ position: 'bottom-start', text: stockBlockText() });
//       } else if (allowNeg && finalValue > maxAllowed) {
//         ToastSwal({ position: 'bottom-start', text: stockWarnText() });
//       }

//       updated[index] = { ...line, transactionQuantityIn: finalValue };
//       formik.setFieldValue('materialTransactionsLineList', updated);
//       return;
//     }

//     updated[index] = { ...line, [field]: value };

//     // ✅ safety
//     if (!showUnitPrice) updated[index].unitPrice = 0;

//     formik.setFieldValue('materialTransactionsLineList', updated);
//   };

//   // =========================
//   // Open picker for line
//   // =========================
//   const openPickerForLine = async (lineIndex: number) => {
//     const ls = values.materialTransactionsLineList || [];
//     const line = ls[lineIndex];
//     if (!line) return;

//     if (!inventoryId) {
//       ToastSwal({
//         position: 'bottom-start',
//         text: i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.'
//       });
//       return;
//     }

//     if (isDisabled) return;

//     const params: any = {
//       InventoryId: inventoryId,
//       Scope: 1
//     };
//     if (subInventoryId) params.SubInventoryId = subInventoryId;

//     const picked = await pickItemUom({
//       title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار الصنف',
//       params,
//       bodyDefaults: { itemType: DEFAULT_ITEM_TYPE },
//       pageSize: 10,
//       searchMode: 'manual',
//       initialSearchField: 'barcodeEqual',
//       isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex),
//       dynamicFields: ['quentity', 'barcode', 'qtyByLot']
//     });

//     if (!picked) return;

//     const row: any = picked.row;
//     if (!row?.itemId || !row?.unitOfMeasure) return;

//     if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
//       ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
//       return;
//     }

//     const allowNeg = row?.authorizeNegativeStock === true;

//     setDetailsMap(prev => {
//       const m = new Map(prev);
//       m.set(`${row.itemId}|${row.unitOfMeasure}`, row);
//       return m;
//     });

//     const updated = [...ls];
//     const currentLine = { ...updated[lineIndex] };

//     updated[lineIndex] = {
//       ...currentLine,
//       transactionItemId: row.itemId,
//       transactionUom: row.unitOfMeasure,
//       lotId: null,
//       _authorizeNegativeStock: allowNeg,
//       unitPrice: showUnitPrice ? Number(currentLine.unitPrice || 0) : 0
//     };

//     formik.setFieldValue('materialTransactionsLineList', updated);

//     ensureItemUomsLoaded(String(row.itemId));
//   };

//   // =========================
//   // Reference fetch
//   // =========================
//   const { itemsList, loading: loading1 } = useAppSelector(state => state.Inv);

//   useEffect(() => {
//     if (['MII', 'MIR'].includes(values.code)) return;

//     if (values.referenceId) {
//       dispatch(fetchDataByReferenceId({ referenceId: values.referenceId, code: values.code }))
//         .unwrap()
//         .then(({ data }) => {
//           // Handle reference data if needed
//         })
//         .catch(error => console.error('Failed to fetch data:', error));
//     }

//     return () => {
//       dispatch(cleanUpItemsList());
//     };
//   }, [values.referenceId, values.code]);




//   // useEffect(() => {
//   //   if (isUpdate === false) {
//   //     const list = (itemsList || []).map((x: any) => ({
//   //       ...x,
//   //       unitPrice: showUnitPrice ? Number(x?.unitPrice || 0) : 0
//   //     }));
//   //     formik.setFieldValue('materialTransactionsLineList', list);
//   //   } else {
//   //     const list = (values.materialTransactionsLineList || []).map((m: any) => {
//   //       const targetItem: any = (itemsList || []).find((f: any) => f.transactionItemId === m.transactionItemId);
//   //       return {
//   //         ...m,
//   //         unitPrice: showUnitPrice ? Number(m?.unitPrice || 0) : 0,
//   //         RealQty: targetItem?.RealQty,
//   //         RemainingQty: Number(m?.transactionQuantityIn) + Number(targetItem?.RemainingQty),
//   //         dispensedQuantity: Number(targetItem?.dispensedQuantity) - Number(m?.transactionQuantityIn)
//   //       };
//   //     });
//   //     formik.setFieldValue('materialTransactionsLineList', list);
//   //   }
//   // }, [itemsList]);



//   // =========================
//   // UI - New table structure
//   // =========================
  
//   // ✅ فقط Add-mode يكتب على القائمة من itemsList
// useEffect(() => {
//   if (isUpdate) return;

//   const list = (itemsList || []).map((x: any) => ({
//     ...x,
//     unitPrice: showUnitPrice ? Number(x?.unitPrice || 0) : 0
//   }));

//   // مهم: لا تشغل validation كل مرة
//   formik.setFieldValue('materialTransactionsLineList', list, false);
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [itemsList, isUpdate, showUnitPrice]);

// // ✅ Update-mode: فقط طبّق قاعدة unitPrice عند تغيير methodTransfer (بدون الاعتماد على itemsList)
// useEffect(() => {
//   if (!isUpdate) return;

//   const ls = values.materialTransactionsLineList || [];
//   if (!ls.length) return;

//   if (!showUnitPrice) {
//     const next = ls.map((l: any) => ({ ...l, unitPrice: 0 }));
//     formik.setFieldValue('materialTransactionsLineList', next, false);
//   }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [isUpdate, showUnitPrice]);

  
  
//   const Lines: any[] = values.materialTransactionsLineList || [];

//   return (
//     <>
//       <Loading loading={loading1} Type='Dots'>
//         <ItemUomPickerModal {...modalProps} />

//         {/* ✅ Header */}
//         <div className='card-header'>
//           <div className='d-flex flex-column flex-md-row justify-content-between gap-3'>
//             <div className='d-flex align-items-center'>
//               <i className='fas fa-dolly-flatbed fs-5 text-theme me-2'></i>
//               <h6 className='mb-0 fw-semibold'>
//                 {t('بنود التحويل المخزني')}
//                 <span className='badge bg-theme rounded-pill ms-2'>{Lines?.length || 0}</span>
//               </h6>

//               {isPosted && (
//                 <span className='badge bg-success ms-2'>{i18n.language === 'en' ? 'Posted' : 'مُرحّل'}</span>
//               )}
//             </div>

//             <div className='d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2'>
//               {(detailsLoading || uomsLoading) && (
//                 <div className='d-flex align-items-center'>
//                   <span className='spinner-border spinner-border-sm text-theme me-2'></span>
//                   <small className='text-muted'>
//                     {detailsLoading ? t('جاري تحميل التفاصيل...') : t('جاري تحميل الوحدات...')}
//                   </small>
//                 </div>
//               )}

//               {canAddLine && !isPosted && (
//                 <button
//                   type='button'
//                   className='btn btn-theme btn-sm d-flex align-items-center justify-content-center px-3 w-100 w-md-auto'
//                   onClick={handleAddLine}
//                 >
//                   <i className='fas fa-plus me-2'></i>
//                   <span>{t('AddItem')}</span>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* ✅ Table */}
//         <div className='card-body p-0'>
//           <div
//             className='table-responsive'
//             style={{ maxHeight: '350px', overflowY: 'auto', overflowX: 'auto', position: 'relative' }}
//           >
//             <table className='table table-hover mb-0' style={{ minWidth: showUnitPrice ? '1100px' : '1000px' }}>
//               <thead
//                 className='shadow fw-bold'
//                 style={{
//                   position: 'sticky',
//                   top: 0,
//                   zIndex: 101,
//                   backdropFilter: 'blur(30px)'
//                 }}
//               >
//                 <tr>
//                   <th
//                     className='text-center small shadow'
//                     style={{ width: '50px', minWidth: '50px', position: 'sticky', left: 0, zIndex: 102 }}
//                   >
//                     #
//                   </th>

//                   <th className='text-center small' style={{ width: '400px', minWidth: '400px' }}>
//                     {t('ItemName')}
//                   </th>

//                   <th className='text-center small' style={{ width: '110px', minWidth: '110px' }}>
//                     {t('Unit')}
//                   </th>

//                   <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
//                     {t('LotNumber')}
//                   </th>

//                   {showUnitPrice && (
//                     <th className='text-center small' style={{ width: '100px', minWidth: '100px' }}>
//                       {t('UnitPrice')}
//                     </th>
//                   )}

//                   <th className='text-center small' style={{ width: '80px', minWidth: '80px' }}>
//                     {t('Quantity')}
//                   </th>

//                   <th className='text-center small' style={{ width: '70px', minWidth: '70px' }}></th>
//                 </tr>
//               </thead>

//               <tbody className='fw-bold'>
//                 {Lines?.length > 0 ? (
//                   Lines.map((line: any, idx: number) => {
//                     const Index = idx;
//                     const infoExact = getInfoExact(line);
//                     const infoLoose = infoExact || getInfoAnyByItemId(line?.transactionItemId);

//                     const itemName = line.transactionItemId ? getItemNameForLine(line) : '';
//                     const uomName = line.transactionItemId ? getUomNameForLine(line) : '';
//                     const barcode = line.transactionItemId ? getBarcodeForLine(line) : '-';

//                     const isDuplicate =
//                       line.transactionItemId &&
//                       line.transactionUom &&
//                       lineHasDuplicateItemUom(line.transactionItemId, line.transactionUom, Index);

//                     const uomOptions = line.transactionItemId
//                       ? uomsByItemId.get(String(line.transactionItemId)) || []
//                       : [];

//                     const lots = Array.isArray(infoExact?.qtyByLot) ? infoExact.qtyByLot : [];
//                     const allRow = {
//                       lotId: null,
//                       lotNumber: i18n.language === 'en' ? 'All' : 'الكل',
//                       expirationDate: null,
//                       qty: lots.reduce((s: number, x: any) => s + n(x?.qty), 0)
//                     };
//                     const lotRowsWithAll = lots.length > 0 ? [allRow, ...lots] : [allRow];

//                     const selectedLot =
//                       lotRowsWithAll.find((x: any) => String(x?.lotId ?? '') === String(line.lotId ?? '')) ?? allRow;

//                     const availableQty = getAvailableQtyForLine(line);
//                     const maxAllowed = getMaxAllowedQty(line);
//                     const negativeAllowedByItem = getNegativeSellingAllowedForLine(line);

//                     const qtyDisabled = isPosted || !canEditQty || !line.transactionItemId;

//                     const displayNo = Index + 1;

//                     return (
//                       <tr key={line?.id ?? Index}>
//                         {/* ✅ sticky # */}
//                         <td
//                           className='text-center align-middle bg-body shadow'
//                           style={{ position: 'sticky', left: 0, zIndex: 100 }}
//                         >
//                           <span className='badge bg-theme bg-opacity-80 fw-bold' style={{ fontSize: '0.85rem' }}>
//                             {displayNo}
//                           </span>
//                         </td>

//                         {/* ✅ Item cell */}
//                         <td className='align-middle'>
//                           <div style={{ width: '100%' }}>
//                             <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
//                               <div className='d-flex align-items-start gap-2'>
//                                 <div className='flex-grow-1' style={{ minWidth: 0 }}>
//                                   {line.transactionItemId ? (
//                                     <>
//                                       <span className='fw-bold text-truncate d-block'>
//                                         {itemName ? (
//                                           itemName
//                                         ) : detailsLoading ? (
//                                           <span className='text-muted'>
//                                             <span className='spinner-border spinner-border-sm me-2'></span>
//                                             {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
//                                           </span>
//                                         ) : (
//                                           `ID: ${line.transactionItemId}`
//                                         )}
//                                       </span>

//                                       <small className='text-muted d-block'>
//                                         {t('Unit')}:{' '}
//                                         <span className='fw-bold text-theme'>
//                                           {uomName || '-'}
//                                         </span>
//                                         <span className='mx-2'>•</span>
//                                         {t('Barcode')}:{' '}
//                                         <span className='fw-bold'>{String(barcode).slice(0, 40)}</span>
//                                       </small>
//                                     </>
//                                   ) : (
//                                     <span className='text-muted'>{t('Choose')}</span>
//                                   )}

//                                   {isDuplicate && (
//                                     <small className='text-danger d-block mt-1'>
//                                       <i className='fas fa-exclamation-triangle me-1'></i>
//                                       {t('هذا الصنف مكرر مع نفس الوحدة')}
//                                     </small>
//                                   )}
//                                 </div>

//                                 {/* Actions */}
//                                 <div className='d-flex gap-1'>
//                                   <button
//                                     disabled={isPosted || !canPickItem || !values.inventoryId}
//                                     type='button'
//                                     className='btn btn-sm btn-theme rounded-0'
//                                     onClick={() => openPickerForLine(Index)}
//                                     title={
//                                       !values.inventoryId
//                                         ? t('يجب اختيار المخزن أولاً.')
//                                         : t('اختيار صنف ووحدة')
//                                     }
//                                   >
//                                     <i className='fas fa-search me-1'></i>
//                                     {line.transactionItemId ? t('تغيير') : t('اختيار')}
//                                   </button>

//                                   {line.transactionItemId && (
//                                     <button
//                                       disabled={isPosted || !canPickItem}
//                                       type='button'
//                                       className='btn btn-sm btn-outline-danger rounded-0'
//                                       onClick={() => handleLineChange(Index, 'clearItem', true)}
//                                       title={t('مسح الصنف')}
//                                     >
//                                       <i className='fas fa-times'></i>
//                                     </button>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </td>

//                         {/* ✅ UOM */}
//                         <td className='align-middle'>
//                           <select
//                             disabled={isPosted || !canChangeUom || !line.transactionItemId}
//                             className={`form-select form-select-sm bg-body ${
//                               isDuplicate ? 'border-danger' : 'border-theme'
//                             }`}
//                             value={line.transactionUom || ''}
//                             onFocus={() => {
//                               if (line.transactionItemId) ensureItemUomsLoaded(String(line.transactionItemId));
//                             }}
//                             onChange={e => handleLineChange(Index, 'transactionUom', e.target.value)}
//                             style={{ width: '100%' }}
//                           >
//                             <option value=''>{t('Choose')}</option>

//                             {line.transactionUom && uomOptions.length === 0 && (
//                               <option value={line.transactionUom}>{uomName || line.transactionUom}</option>
//                             )}

//                             {uomOptions.map((u: any) => {
//                               const uomVal = u.unitOfMeasure;
//                               const label =
//                                 (i18n.language === 'en'
//                                   ? u.unitOfMeasureName || u.unitOfMeasureName2
//                                   : u.unitOfMeasureName2 || u.unitOfMeasureName) || `ID: ${uomVal}`;

//                               return (
//                                 <option key={uomVal} value={uomVal}>
//                                   {label}
//                                 </option>
//                               );
//                             })}

//                             {uomsLoading && line.transactionItemId ? (
//                               <option value={line.transactionUom || ''} disabled>
//                                 {i18n.language === 'en' ? 'Loading...' : '...جاري التحميل'}
//                               </option>
//                             ) : null}
//                           </select>
//                         </td>

//                         {/* ✅ Lot */}
//                         <td className='align-middle'>
//                           {(() => {
//                             const disabled = isPosted || !line.transactionItemId;

//                             const lotLabel = selectedLot?.lotNumber || (i18n.language === 'en' ? 'All' : 'الكل');

//                             return (
//                               <div className='d-flex flex-column gap-1'>
//                                 <div
//                                   className='input-group input-group-sm border border-theme'
//                                   onClick={() => {
//                                     if (disabled) return;
//                                     openLotPicker(
//                                       Index,
//                                       lotRowsWithAll as any,
//                                       line.lotId,
//                                       itemName || `ID: ${line.transactionItemId}`
//                                     );
//                                   }}
//                                   style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
//                                 >
//                                   <input
//                                     readOnly
//                                     className='form-control form-control-sm  bg-body'
//                                     value={lotLabel}
//                                     placeholder={t('AllLots')}
//                                     disabled={disabled}
//                                   />
//                                   <span className='input-group-text border-0 bg-body'>
//                                     <i className='fas fa-caret-down'></i>
//                                   </span>
//                                 </div>
//                               </div>
//                             );
//                           })()}
//                         </td>

//                         {/* ✅ Unit Price (conditional) */}
//                         {showUnitPrice && (
//                           <td className='align-middle'>
//                             <NumericFormat
//                               value={Number(line.unitPrice || 0)}
//                               thousandSeparator=','
//                               decimalSeparator='.'
//                               decimalScale={2}
//                               allowNegative={false}
//                               className='form-control form-control-sm text-center px-0 border-theme bg-body'
//                               disabled={isPosted || !line.transactionItemId}
//                               onValueChange={v => handleLineChange(Index, 'unitPrice', v.floatValue ?? 0)}
//                             />
//                           </td>
//                         )}

//                         {/* ✅ Qty */}
//                         <td className='align-middle'>
//                           <PopoverCustom
//                             childern={
//                               <NumericFormat
//                                 value={line.transactionQuantityIn}
//                                 thousandSeparator=','
//                                 decimalSeparator='.'
//                                 decimalScale={0}
//                                 allowNegative={false}
//                                 className='form-control form-control-sm text-center px-0 border-theme bg-body'
//                                 disabled={qtyDisabled}
//                                 onValueChange={v => handleLineChange(Index, 'transactionQuantityIn', v.floatValue ?? 0)}
//                                 onInput={(e: any) => {
//                                   if (isPosted) return;
//                                   const input = e.target as HTMLInputElement;
//                                   const entered = Number(input.value.replace(/[^0-9]/g, ''));
//                                   if (!Number.isFinite(maxAllowed)) return;
//                                   if (entered > maxAllowed) input.value = String(maxAllowed);
//                                 }}
//                               />
//                             }
//                             Header={
//                               isPosted
//                                 ? i18n.language === 'en'
//                                   ? `Posted Qty: ${n(line.transactionQuantityIn)} • Onhand now: ${availableQty}`
//                                   : `الكمية المُرحلة: ${n(line.transactionQuantityIn)} • المتاح الآن: ${availableQty}`
//                                 : i18n.language === 'en'
//                                   ? `Available: ${availableQty}`
//                                   : `${t('AvailableQuantity')} : ${availableQty}`
//                             }
//                             Body={
//                               !(infoExact || infoLoose) ? (
//                                 <div className='text-muted small'>
//                                   {i18n.language === 'en' ? 'Details not loaded.' : 'لم يتم تحميل تفاصيل الصنف.'}
//                                 </div>
//                               ) : isPosted ? (
//                                 <div className='d-flex flex-column gap-1'>
//                                   <div className='d-flex justify-content-between'>
//                                     <span>{i18n.language === 'en' ? 'Posted Qty' : 'الكمية المُرحلة'}</span>
//                                     <span className='fw-bold text-theme'>{n(line.transactionQuantityIn)}</span>
//                                   </div>

//                                   <div className='d-flex justify-content-between'>
//                                     <span>{i18n.language === 'en' ? 'Onhand now' : 'المتاح الآن'}</span>
//                                     <span className='fw-bold text-success'>{availableQty}</span>
//                                   </div>

//                                   <div className='d-flex justify-content-between'>
//                                     <span className='me-4'>
//                                       {i18n.language === 'en' ? 'Selected Lot :' : 'رقم التشغيل : '}
//                                     </span>
//                                     <span className='fw-bold'>
//                                       {selectedLot?.lotNumber || (i18n.language === 'en' ? 'All' : 'الكل')}
//                                     </span>
//                                   </div>

//                                   <div className='d-flex justify-content-between'>
//                                     <span className='me-4'>
//                                       {i18n.language === 'en' ? 'Item Neg Stock' : 'بيع بالسالب :'}
//                                     </span>
//                                     <span className='fw-bold'>
//                                       {negativeAllowedByItem
//                                         ? i18n.language === 'en'
//                                           ? 'Yes'
//                                           : 'مسموح'
//                                         : i18n.language === 'en'
//                                           ? 'No'
//                                           : 'غير مسموح'}
//                                     </span>
//                                   </div>
//                                 </div>
//                               ) : (
//                                 <div className='d-flex flex-column gap-1'>
//                                   <div className='d-flex justify-content-between'>
//                                     <span>{i18n.language === 'en' ? 'Max Allowed' : 'الحد المسموح'}</span>
//                                     <span className='fw-bold text-theme'>
//                                       {Number.isFinite(maxAllowed) ? maxAllowed : '∞'}
//                                     </span>
//                                   </div>

//                                   <div className='d-flex justify-content-between'>
//                                     <span>{i18n.language === 'en' ? 'Item Neg Stock' : 'سالب الصنف'}</span>
//                                     <span className='fw-bold'>
//                                       {negativeAllowedByItem
//                                         ? i18n.language === 'en'
//                                           ? 'Yes'
//                                           : 'مسموح'
//                                         : i18n.language === 'en'
//                                           ? 'No'
//                                           : 'غير مسموح'}
//                                     </span>
//                                   </div>

//                                   <div className='d-flex justify-content-between'>
//                                     <span>{i18n.language === 'en' ? 'Selected Lot' : 'اللوت المختار'}</span>
//                                     <span className='fw-bold'>
//                                       {selectedLot?.lotNumber || (i18n.language === 'en' ? 'All' : 'الكل')}
//                                     </span>
//                                   </div>
//                                 </div>
//                               )
//                             }
//                           />
//                         </td>

//                         {/* ✅ Delete */}
//                         <td className='align-middle text-center'>
//                           {canDeleteLine && !isPosted ? (
//                             <button
//                               type='button'
//                               className='btn btn-sm btn-danger rounded-0'
//                               onClick={() => handleDeleteLine(Index)}
//                               title={t('Delete Line')}
//                               style={{ width: '28px', height: '28px', padding: '0' }}
//                             >
//                               <i className='fas fa-trash text-white'></i>
//                             </button>
//                           ) : (
//                             <span className='text-muted'>-</span>
//                           )}
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={showUnitPrice ? 7 : 6} className='text-center py-4 text-muted'>
//                       <i className='fa fa-inbox fa-2x mb-2'></i>
//                       <br />
//                       {t('لا توجد أصناف مضافة')}
//                       <br />
//                       {canAddLine && !isPosted && (
//                         <button type='button' className='btn btn-theme mt-3' onClick={handleAddLine}>
//                           <i className='fas fa-plus me-2'></i>
//                           {t('إضافة اول صنف')}
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {formik.errors.materialTransactionsLineList?.length ? <div className='text-danger p-2'> * مطلوب </div> : null}
//         </div>

//         {/* ✅ Card Footer */}
//         <div className='card-footer d-flex justify-content-between align-items-center'>
//           <div className='text-muted small'>
//             <i className='fas fa-list me-1'></i>
//             {t('عدد الأصناف')}: <span className='fw-bold'>{Lines?.length || 0}</span>
//           </div>

//           <div className='text-theme fw-bold'>
//             <i className='fas fa-info-circle me-2'></i>
//             {isPosted ? (i18n.language === 'en' ? 'Read only (Posted)' : 'قراءة فقط (مُرحّل)') : '-'}
//           </div>
//         </div>
//       </Loading>

//       {/* ✅ Lot Picker Modal */}
//       <NeatixModal
//         show={lotPickerOpen}
//         setShow={(v: boolean) => (v ? setLotPickerOpen(true) : closeLotPicker())}
//         bodyClassName='p-0'
//         size='lg'
//         showHeader={false}
//         centered
//       >
//         <div className='p-3'>
//           <div className='d-flex justify-content-between align-items-center mb-2'>
//             <div className='fw-bold'>
//               <i className='fas fa-layer-group me-2'></i>
//               {i18n.language === 'en' ? 'Select Lot' : 'اختيار اللوت'}
//               {lotPickerItemTitle ? <span className='text-muted ms-2'>— {lotPickerItemTitle}</span> : null}
//             </div>

//             <button type='button' className='btn btn-sm btn-outline-secondary' onClick={closeLotPicker}>
//               <i className='fas fa-times'></i>
//             </button>
//           </div>

//           <div className='input-group input-group-sm mb-2'>
//             <span className='input-group-text'>{i18n.language === 'en' ? 'Search' : 'بحث'}</span>
//             <input
//               className='form-control'
//               value={lotSearch}
//               onChange={e => setLotSearch(e.target.value)}
//               placeholder={i18n.language === 'en' ? 'Type lot number...' : 'اكتب رقم اللوت...'}
//               autoFocus
//             />
//           </div>

//           <div className='table-responsive' style={{ maxHeight: '55vh', overflow: 'auto' }}>
//             <table className='table table-hover table-sm mb-0'>
//               <thead className='bg-theme bg-opacity-10'>
//                 <tr>
//                   <th style={{ width: '45%' }}>{t('LotNumber')}</th>
//                   <th style={{ width: '35%' }}>{t('ExpirationDate')}</th>
//                   <th className='text-end' style={{ width: '20%' }}>
//                     {t('AvailableQuantity')}
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {(filteredLotRows || []).map((r: any) => {
//                   const isAll = r?.lotId == null;
//                   const lotNo = isAll ? (i18n.language === 'en' ? 'All' : 'الكل') : r?.lotNumber || '-';
//                   const exp = r?.expirationDate ? String(r.expirationDate).split('T')[0] : null;
//                   const avail = isAll ? n(r?.qty) : n(r?.qty);

//                   const active = String(lotPickerSelectedLotId ?? '') === String(r?.lotId ?? '');

//                   return (
//                     <tr
//                       key={String(r?.lotId ?? 'ALL')}
//                       role='button'
//                       className={active ? 'table-active' : ''}
//                       onClick={() => chooseLot(r?.lotId)}
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <td className='fw-bold'>{isAll ? <span className='text-theme'>{lotNo}</span> : lotNo}</td>
//                       <td className='text-muted'>
//                         {isAll ? '-' : exp || (i18n.language === 'en' ? 'No Exp' : 'بدون تاريخ')}
//                       </td>
//                       <td className='text-end fw-bold text-theme'>{avail}</td>
//                     </tr>
//                   );
//                 })}

//                 {(!filteredLotRows || filteredLotRows.length === 0) && (
//                   <tr>
//                     <td colSpan={3} className='text-center text-muted py-4'>
//                       {i18n.language === 'en' ? 'No lots found.' : 'لا توجد لوتات مطابقة.'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </NeatixModal>
//     </>
//   );
// };

// export default MoveLines;


import React, { useEffect, useMemo, useRef, useState } from 'react';
import { type FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
import ToastSwal from '@components/Shared/Alert/ToastSwal';
import { NumericFormat } from 'react-number-format';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { cleanUpItemsList, fetchDataByReferenceId } from '@store/INV/Transactions/InvIssue/invSlice';

// ✅ Picker
import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';

// ✅ API
import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

// ✅ Logic (same as POLines)
import {
  lookupBestRowByBarcode,
  mergeIntoDetailsMap,
  makeDetailsKey
} from '@pages/INV/lookups/itemsWithUomLookup.logic';

import NeatixModal from '@components/Modal/NeatixModal';

interface LinesProps {
  formik: FormikProps<any>;
  isUpdate?: boolean;
  isPosted?: boolean;
  canAddLine?: boolean;
  canDeleteLine?: boolean;
  canPickItem?: boolean;
  canEditQty?: boolean;
  canChangeUom?: boolean;
}

type ItemType = 'InventoryItem';
const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

const n = (value: any) => Number(value || 0);

const MoveLines: React.FC<LinesProps> = ({
  formik,
  isUpdate = false,
  isPosted = false,
  canAddLine = true,
  canDeleteLine = true,
  canPickItem = true,
  canEditQty = true,
  canChangeUom = true
}) => {
  const { values } = formik;
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  // ✅ Picker
  const { pickItemUom, modalProps } = useItemUomPicker();

  // =========================
  // Context
  // =========================
  const inventoryId: string | null = values?.inventoryId ?? null;
  const subInventoryId: string | null = values?.subInventoryId ?? null;

  // ✅ pricing rule:
  // 1 => no price column
  // 2 => show price column (user input)
  const methodTransfer = Number(values?.methodTransfer ?? 0);
  const showUnitPrice = methodTransfer === 2;

  const IsEnabledByCode = () => {
    return ['SPR', 'WOI', 'IOI', 'CCA', 'SOI', 'INV', 'MOI', 'MOR', 'IOR', 'BIL', 'POR', 'PIA', 'CRT'].includes(
      values.code
    );
  };
  const isDisabled = IsEnabledByCode();

  // =========================
  // ✅ Details map (ItemId|UOM -> row)
  // =========================
  const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
  const [detailsLoading, setDetailsLoading] = useState(false);
  const abortRef = useRef<AbortController | null>(null);

  const getInfoExact = (line: any) => {
    if (!line?.transactionItemId || !line?.transactionUom) return null;
    return detailsMap.get(makeDetailsKey(line.transactionItemId, line.transactionUom)) || null;
  };

  const getInfoAnyByItemId = (itemId: string) => {
    if (!itemId) return null;
    for (const [key, value] of detailsMap.entries()) {
      if (key.startsWith(`${itemId}|`)) return value;
    }
    return null;
  };

  const getItemNameForLine = (line: any) => {
    const info = (getInfoExact(line) as any) || getInfoAnyByItemId(line?.transactionItemId);
    const isEn = i18n.language === 'en';
    const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
    return name || '';
  };

  const getUomNameForLine = (line: any) => {
    const info = (getInfoExact(line) as any) || getInfoAnyByItemId(line?.transactionItemId);
    const isEn = i18n.language === 'en';
    const uomName = isEn
      ? info?.unitOfMeasureName || info?.unitOfMeasureName2
      : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
    return uomName || '';
  };

  const getBarcodeForLine = (line: any) => {
    const info = (getInfoExact(line) as any) || getInfoAnyByItemId(line?.transactionItemId);
    return info?.barcode || '';
  };

  // =========================
  // ✅ Barcode Scan (quick add) — like POLines
  // =========================
  const barcodeInputRef = useRef<HTMLInputElement | null>(null);
  const barcodeAbortRef = useRef<AbortController | null>(null);
  const [barcodeTerm, setBarcodeTerm] = useState('');
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [barcodeError, setBarcodeError] = useState<string | null>(null);

  useEffect(() => {
    setBarcodeError(null);
    if (!inventoryId) return;
    const h = window.setTimeout(() => barcodeInputRef.current?.focus(), 50);
    return () => window.clearTimeout(h);
  }, [inventoryId, subInventoryId]);

  const addLineByBarcode = async (rawBarcode: string) => {
    const barcode = String(rawBarcode || '').trim();
    if (!barcode) return;

    setBarcodeError(null);

    if (isPosted || !canPickItem || isDisabled) return;

    if (!inventoryId) {
      const msg = i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.';
      setBarcodeError(msg);
      ToastSwal({ position: 'bottom-start', text: msg });
      barcodeInputRef.current?.focus();
      return;
    }

    barcodeAbortRef.current?.abort();
    barcodeAbortRef.current = new AbortController();

    setBarcodeLoading(true);

    try {
      const params: any = {
        InventoryId: inventoryId,
        Scope: 1
      };
      if (subInventoryId) params.SubInventoryId = subInventoryId;

      const picked: any = await lookupBestRowByBarcode({
        params,
        itemType: DEFAULT_ITEM_TYPE,
        barcode,
        pageSize: 30,
        pageIndex: 1,
        barcodeField: 'barcodeEqual',
        opts: { signal: barcodeAbortRef.current.signal }
      });

      if (!picked?.itemId || !picked?.unitOfMeasure) {
        const msg = i18n.language === 'en' ? 'Barcode not found.' : 'لا يوجد صنف بهذا الباركود.';
        setBarcodeError(msg);
        ToastSwal({ position: 'bottom-start', text: msg });
        barcodeInputRef.current?.focus();
        return;
      }

      // ✅ store for display
      setDetailsMap(prev => mergeIntoDetailsMap(prev, [picked]));

      // ✅ preload UOMs for this item
      ensureItemUomsLoaded(String(picked.itemId));

      const lines = [...(values.materialTransactionsLineList || [])];

      const existingIndex = lines.findIndex(
        (l: any) =>
          String(l?.transactionItemId || '') === String(picked.itemId) &&
          String(l?.transactionUom || '') === String(picked.unitOfMeasure)
      );

      const allowNeg = picked?.authorizeNegativeStock === true;
      const availableQtyRaw = picked?.quentity;
      const availableQty = Number.isFinite(Number(availableQtyRaw)) ? Math.max(0, Number(availableQtyRaw)) : 0;

      // ✅ if exists => increment qty
      if (existingIndex >= 0) {
        const current = { ...lines[existingIndex] };
        const nextQty = n(current.transactionQuantityIn) + 1;

        // block/warn rule
        if (!allowNeg && nextQty > availableQty) {
          current.transactionQuantityIn = availableQty;
          ToastSwal({ position: 'bottom-start', text: stockBlockText() });
        } else {
          current.transactionQuantityIn = nextQty;
          if (allowNeg && nextQty > availableQty) {
            ToastSwal({ position: 'bottom-start', text: stockWarnText() });
          }
        }

        // price safety
        if (!showUnitPrice) current.unitPrice = 0;

        lines[existingIndex] = current;
        formik.setFieldValue('materialTransactionsLineList', lines);
      } else {
        // ✅ new line
        let qty = 1;

        if (!allowNeg && qty > availableQty) {
          qty = availableQty; // غالباً 0
          ToastSwal({ position: 'bottom-start', text: stockBlockText() });
        } else if (allowNeg && qty > availableQty) {
          ToastSwal({ position: 'bottom-start', text: stockWarnText() });
        }

        const newLine: any = {
          id: null,
          transactionItemId: picked.itemId,
          transactionUom: picked.unitOfMeasure,
          unitPrice: showUnitPrice ? Number(0) : 0,
          transactionQuantityIn: qty,
          transactionQuantityOut: 0,
          lotId: null,
          inventoryId: inventoryId ?? '',
          discount: 0,
          codeCombinationId: '',
          currencyCode: '',
          currencyConversionRate: 0,
          referenceIdMaster: '',
          referenceIdLine: '',
          transactionTypeId: '',
          equivalent: 0,
          expensesAmount: 0,
          batchId: '',
          _availableQty: availableQty,
          _qtyOver: false,
          _qtyOverMode: null,
          _authorizeNegativeStock: allowNeg
        };

        formik.setFieldValue('materialTransactionsLineList', [...lines, newLine]);
      }

      setBarcodeTerm('');
      barcodeInputRef.current?.focus();
    } catch (e: any) {
      if (e?.name !== 'CanceledError') {
        console.error(e);
        const msg = i18n.language === 'en' ? 'Failed to lookup barcode.' : 'تعذر البحث عن الباركود.';
        setBarcodeError(msg);
        ToastSwal({ position: 'bottom-start', text: msg });
      }
    } finally {
      setBarcodeLoading(false);
    }
  };

  // =========================
  // Lot Handling
  // =========================
  const [lotPickerOpen, setLotPickerOpen] = useState(false);
  const [lotPickerLineIndex, setLotPickerLineIndex] = useState<number | null>(null);
  const [lotPickerItemTitle, setLotPickerItemTitle] = useState('');
  const [lotPickerLotRows, setLotPickerLotRows] = useState<any[]>([]);
  const [lotPickerSelectedLotId, setLotPickerSelectedLotId] = useState<string | null>(null);
  const [lotSearch, setLotSearch] = useState('');

  const openLotPicker = (lineIndex: number, lotRows: any[], currentLotId: string | null, itemTitle: string) => {
    setLotPickerLineIndex(lineIndex);
    setLotPickerItemTitle(itemTitle);
    setLotPickerLotRows(lotRows);
    setLotPickerSelectedLotId(currentLotId);
    setLotSearch('');
    setLotPickerOpen(true);
  };

  const closeLotPicker = () => {
    setLotPickerOpen(false);
    setLotPickerLineIndex(null);
    setLotPickerLotRows([]);
    setLotPickerItemTitle('');
    setLotPickerSelectedLotId(null);
    setLotSearch('');
  };

  const chooseLot = (lotId: string | null) => {
    if (lotPickerLineIndex === null) return;

    const updated = [...(values.materialTransactionsLineList || [])];
    updated[lotPickerLineIndex] = { ...updated[lotPickerLineIndex], lotId };
    formik.setFieldValue('materialTransactionsLineList', updated);

    closeLotPicker();
  };

  const filteredLotRows = useMemo(() => {
    if (!lotSearch.trim()) return lotPickerLotRows;
    return lotPickerLotRows.filter((r: any) => {
      const lotNumber = r?.lotNumber || '';
      return lotNumber.toLowerCase().includes(lotSearch.toLowerCase());
    });
  }, [lotPickerLotRows, lotSearch]);

  // =========================
  // Duplicate rules (item+uom)
  // =========================
  const lineHasDuplicateItemUom = (itemId: any, uom: any, excludeIndex: number) => {
    if (!itemId || !uom) return false;
    return (values.materialTransactionsLineList || []).some((l: any, i: number) => {
      if (i === excludeIndex) return false;
      return String(l?.transactionItemId || '') === String(itemId) && String(l?.transactionUom || '') === String(uom);
    });
  };

  // =========================
  // authorizeNegativeStock
  // =========================
  const stockWarnText = () =>
    i18n.language === 'en'
      ? 'Quantity exceeds available stock (negative selling allowed).'
      : 'الكمية أكبر من المتوفر (مسموح السالب).';

  const stockBlockText = () => (i18n.language === 'en' ? 'Quantity exceeds available stock.' : 'الكمية المطلوبة أكبر من المتوفر.');

  const getNegativeSellingAllowedForLine = (line: any) => {
    const info = getInfoExact(line) as any;
    const v = info?.authorizeNegativeStock ?? line?._authorizeNegativeStock;
    return v === true;
  };

  const getAvailableQtyForLine = (line: any): number => {
    const info = (getInfoExact(line) as any) || getInfoAnyByItemId(line?.transactionItemId);
    const q = info?.quentity;
    if (q == null || q === '') return 0;
    const nn = Number(q);
    return Number.isFinite(nn) ? Math.max(0, nn) : 0;
  };

  const getMaxAllowedQty = (line: any) => {
    const availableQty = getAvailableQtyForLine(line);
    const allowNeg = getNegativeSellingAllowedForLine(line);
    return allowNeg ? Infinity : availableQty;
  };

  // =========================
  // linesKey (reload details only when itemId/uom changes)
  // =========================
  const linesKey = useMemo(() => {
    const ls = values.materialTransactionsLineList || [];
    return ls.map((l: any) => `${l?.transactionItemId || ''}:${l?.transactionUom || ''}`).join('|');
  }, [values.materialTransactionsLineList]);

  // =========================
  // Update-mode: load missing details
  // =========================
  useEffect(() => {
    const run = async () => {
      if (!inventoryId) return;

      const ls = values.materialTransactionsLineList || [];
      const valid = ls.filter((l: any) => l?.transactionItemId && l?.transactionUom);
      if (!valid.length) return;

      const missing = valid.filter((l: any) => {
        const key = makeDetailsKey(l.transactionItemId, l.transactionUom);
        return !detailsMap.has(key);
      });

      if (!missing.length) return;

      abortRef.current?.abort();
      abortRef.current = new AbortController();

      setDetailsLoading(true);
      try {
        const params: any = {
          InventoryId: inventoryId,
          Scope: 1
        };
        if (subInventoryId) params.SubInventoryId = subInventoryId;

        const resp = await fetchItemsWithUomLookup(
          params,
          {
            pageIndex: 1,
            pageSize: 1500,
            itemType: DEFAULT_ITEM_TYPE,
            itemIds: missing.map((l: any) => l.transactionItemId)
          } as any,
          abortRef.current.signal
        );

        const rows: any[] = resp.data?.data || [];
        if (rows?.length) {
          setDetailsMap(prev => mergeIntoDetailsMap(prev, rows as any));
        }
      } catch (e: any) {
        if (e?.name !== 'CanceledError') console.error(e);
      } finally {
        setDetailsLoading(false);
      }
    };

    if (isUpdate === true) run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoryId, subInventoryId, linesKey, isUpdate]);

  // clear details when context changes
  const loadedUomsRef = useRef(new Set<string>());
  useEffect(() => {
    setDetailsMap(new Map());
    loadedUomsRef.current.clear();
  }, [inventoryId, subInventoryId]);

  // =========================
  // UOM options per item
  // =========================
  const uomsByItemId = useMemo(() => {
    const map = new Map<string, ItemWithUomRow[]>();
    for (const r of detailsMap.values()) {
      const itemId = String((r as any)?.itemId ?? '');
      if (!itemId) continue;
      const list = map.get(itemId) ?? [];
      list.push(r);
      map.set(itemId, list);
    }

    for (const [itemId, list] of map.entries()) {
      const uniq = new Map<string, ItemWithUomRow>();
      for (const r of list) uniq.set(String((r as any).unitOfMeasure), r);
      map.set(itemId, Array.from(uniq.values()));
    }

    return map;
  }, [detailsMap]);

  const uomsAbortRef = useRef<AbortController | null>(null);
  const [uomsLoading, setUomsLoading] = useState(false);

  const ensureItemUomsLoaded = async (itemId: string) => {
    if (!inventoryId || !itemId) return;

    const key = `${inventoryId}|${subInventoryId || ''}|${DEFAULT_ITEM_TYPE}|${itemId}`;
    if (loadedUomsRef.current.has(key)) return;
    loadedUomsRef.current.add(key);

    try {
      uomsAbortRef.current?.abort();
      uomsAbortRef.current = new AbortController();
      setUomsLoading(true);

      const params: any = { InventoryId: inventoryId, Scope: 1 };
      if (subInventoryId) params.SubInventoryId = subInventoryId;

      const resp = await fetchItemsWithUomLookup(
        params,
        {
          pageIndex: 1,
          pageSize: 3000,
          itemType: DEFAULT_ITEM_TYPE,
          itemIds: [itemId]
        } as any,
        uomsAbortRef.current.signal
      );

      const list: any[] = resp?.data?.data || [];
      if (!Array.isArray(list) || list.length === 0) return;

      setDetailsMap(prev => mergeIntoDetailsMap(prev, list as any));
    } catch (e: any) {
      if (e?.name !== 'CanceledError') {
        loadedUomsRef.current.delete(key);
        console.error(e);
      }
    } finally {
      setUomsLoading(false);
    }
  };

  // =========================
  // Line handlers
  // =========================
  const resetLine = (line: any) => ({
    ...line,
    transactionItemId: null,
    transactionUom: '',
    transactionQuantityIn: 0,
    lotId: null,
    unitPrice: 0,
    _availableQty: null,
    _qtyOver: false,
    _qtyOverMode: null,
    _authorizeNegativeStock: null
  });

  const handleAddLine = () => {
    const newLine: any = {
      id: null,
      transactionItemId: null,
      transactionUom: '',
      unitPrice: 0,
      transactionQuantityIn: 0,
      transactionQuantityOut: 0,
      lotId: null,
      inventoryId: '',
      discount: 0,
      codeCombinationId: '',
      currencyCode: '',
      currencyConversionRate: 0,
      referenceIdMaster: '',
      referenceIdLine: '',
      transactionTypeId: '',
      equivalent: 0,
      expensesAmount: 0,
      batchId: '',
      _availableQty: null,
      _qtyOver: false,
      _qtyOverMode: null,
      _authorizeNegativeStock: null
    };

    const currentLines = values.materialTransactionsLineList || [];
    formik.setFieldValue('materialTransactionsLineList', [...currentLines, newLine]);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = (values.materialTransactionsLineList || []).filter((_: any, i: number) => i !== index);
    formik.setFieldValue('materialTransactionsLineList', updatedLines);
  };

  const handleLineChange = (index: number, field: string, value: any) => {
    const updated = [...(values.materialTransactionsLineList || [])];
    if (!updated[index]) return;

    const line = { ...updated[index] };

    if (field === 'clearItem') {
      updated[index] = resetLine(line);
      formik.setFieldValue('materialTransactionsLineList', updated);
      return;
    }

    // ✅ ممنوع تعديل السعر إذا ما نعرضه
    if (field === 'unitPrice' && !showUnitPrice) return;

    if (field === 'transactionUom') {
      if (line.transactionItemId && lineHasDuplicateItemUom(line.transactionItemId, value, index)) {
        ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
        return;
      }

      const next = { ...line, transactionUom: value };
      if (!showUnitPrice) next.unitPrice = 0;

      updated[index] = next;
      formik.setFieldValue('materialTransactionsLineList', updated);
      return;
    }

    if (field === 'transactionQuantityIn') {
      const maxAllowed = getMaxAllowedQty(line);
      const allowNeg = getNegativeSellingAllowedForLine(line);

      let finalValue = Number(value);

      if (!allowNeg && finalValue > maxAllowed) {
        finalValue = maxAllowed;
        ToastSwal({ position: 'bottom-start', text: stockBlockText() });
      } else if (allowNeg) {
        const avail = getAvailableQtyForLine(line);
        if (finalValue > avail) ToastSwal({ position: 'bottom-start', text: stockWarnText() });
      }

      updated[index] = { ...line, transactionQuantityIn: finalValue };
      if (!showUnitPrice) updated[index].unitPrice = 0;

      formik.setFieldValue('materialTransactionsLineList', updated);
      return;
    }

    updated[index] = { ...line, [field]: value };
    if (!showUnitPrice) updated[index].unitPrice = 0;

    formik.setFieldValue('materialTransactionsLineList', updated);
  };

  // =========================
  // Open picker for line
  // =========================
  const openPickerForLine = async (lineIndex: number) => {
    const ls = values.materialTransactionsLineList || [];
    const line = ls[lineIndex];
    if (!line) return;

    if (!inventoryId) {
      ToastSwal({
        position: 'bottom-start',
        text: i18n.language === 'en' ? 'Select inventory first.' : 'اختر المخزن أولاً.'
      });
      return;
    }

    if (isDisabled) return;

    const params: any = {
      InventoryId: inventoryId,
      Scope: 1
    };
    if (subInventoryId) params.SubInventoryId = subInventoryId;

    const picked = await pickItemUom({
      title: i18n.language === 'en' ? 'Pick Item & UOM' : 'اختيار الصنف',
      params,
      bodyDefaults: { itemType: DEFAULT_ITEM_TYPE },
      pageSize: 10,
      searchMode: 'manual',
      initialSearchField: 'barcodeEqual',
      isDisabledRow: (r: any) => lineHasDuplicateItemUom(r.itemId, r.unitOfMeasure, lineIndex),
      dynamicFields: ['quentity', 'barcode', 'qtyByLot']
    });

    if (!picked) return;

    const row: any = picked.row;
    if (!row?.itemId || !row?.unitOfMeasure) return;

    if (lineHasDuplicateItemUom(row.itemId, row.unitOfMeasure, lineIndex)) {
      ToastSwal({ position: 'bottom-start', text: 'لا يمكن تكرار نفس الصنف بنفس الوحدة.' });
      return;
    }

    const allowNeg = row?.authorizeNegativeStock === true;

    setDetailsMap(prev => mergeIntoDetailsMap(prev, [row]));

    const updated = [...ls];
    const currentLine = { ...updated[lineIndex] };

    updated[lineIndex] = {
      ...currentLine,
      transactionItemId: row.itemId,
      transactionUom: row.unitOfMeasure,
      lotId: null,
      _authorizeNegativeStock: allowNeg,
      unitPrice: showUnitPrice ? Number(currentLine.unitPrice || 0) : 0
    };

    formik.setFieldValue('materialTransactionsLineList', updated);

    ensureItemUomsLoaded(String(row.itemId));
  };

  // =========================
  // Reference fetch
  // =========================
  const { itemsList, loading: loading1 } = useAppSelector(state => state.Inv);

  useEffect(() => {
    if (['MII', 'MIR'].includes(values.code)) return;

    if (values.referenceId) {
      dispatch(fetchDataByReferenceId({ referenceId: values.referenceId, code: values.code }))
        .unwrap()
        .then(({ data }) => {
          // optional
        })
        .catch(error => console.error('Failed to fetch data:', error));
    }

    return () => {
      dispatch(cleanUpItemsList());
    };
  }, [values.referenceId, values.code]);

  // ✅ Add-mode: write from itemsList
  useEffect(() => {
    if (isUpdate) return;

    const list = (itemsList || []).map((x: any) => ({
      ...x,
      unitPrice: showUnitPrice ? Number(x?.unitPrice || 0) : 0
    }));

    formik.setFieldValue('materialTransactionsLineList', list, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsList, isUpdate, showUnitPrice]);

  // ✅ Update-mode: enforce price rule when methodTransfer changes
  useEffect(() => {
    if (!isUpdate) return;

    const ls = values.materialTransactionsLineList || [];
    if (!ls.length) return;

    if (!showUnitPrice) {
      const next = ls.map((l: any) => ({ ...l, unitPrice: 0 }));
      formik.setFieldValue('materialTransactionsLineList', next, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdate, showUnitPrice]);

  const Lines: any[] = values.materialTransactionsLineList || [];

  return (
    <>
      <Loading loading={loading1} Type='Dots'>
        <ItemUomPickerModal {...modalProps} />

        {/* ✅ Header */}
        <div className='card-header'>
          <div className='d-flex flex-column flex-md-row justify-content-between gap-3'>
            <div className='d-flex align-items-center'>
              <i className='fas fa-dolly-flatbed fs-5 text-theme me-2'></i>
              <h6 className='mb-0 fw-semibold'>
                {t('بنود التحويل المخزني')}
                <span className='badge bg-theme rounded-pill ms-2'>{Lines?.length || 0}</span>
              </h6>

              {isPosted && (
                <span className='badge bg-success ms-2'>{i18n.language === 'en' ? 'Posted' : 'مُرحّل'}</span>
              )}
            </div>

            <div className='d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2'>
              {(detailsLoading || uomsLoading) && (
                <div className='d-flex align-items-center'>
                  <span className='spinner-border spinner-border-sm text-theme me-2'></span>
                  <small className='text-muted'>
                    {detailsLoading ? t('جاري تحميل التفاصيل...') : t('جاري تحميل الوحدات...')}
                  </small>
                </div>
              )}

              {/* ✅ Barcode Quick Add (like POLines) */}
              {!isPosted && canPickItem && (
                <div className='position-relative w-100 w-md-auto' style={{ minWidth: '240px', maxWidth: '320px' }}>
                  <div className='input-group input-group-sm w-100'>
                    <span className='input-group-text'>
                      <i className='fas fa-barcode text-muted'></i>
                    </span>

                    <input
                      ref={barcodeInputRef}
                      value={barcodeTerm}
                      onChange={e => {
                        setBarcodeTerm(e.target.value);
                        if (barcodeError) setBarcodeError(null);
                      }}
                      onKeyDown={e => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          addLineByBarcode(barcodeTerm);
                        }
                        if (e.key === 'Escape') {
                          setBarcodeTerm('');
                          setBarcodeError(null);
                        }
                      }}
                      className='form-control'
                      disabled={!inventoryId || barcodeLoading || isDisabled}
                      placeholder={t('امسح الباركود أو أدخل الرقم')}
                      inputMode='numeric'
                    />

                    {barcodeLoading ? (
                      <span className='input-group-text'>
                        <span className='spinner-border spinner-border-sm text-theme' />
                      </span>
                    ) : (
                      <button
                        className='input-group-text'
                        onClick={() => barcodeTerm && addLineByBarcode(barcodeTerm)}
                        disabled={!barcodeTerm || barcodeLoading || !inventoryId || isDisabled}
                        title={t('إضافة')}
                      >
                        <i className='fas fa-plus text-theme'></i>
                      </button>
                    )}
                  </div>

                  {barcodeError && (
                    <div className='position-absolute top-100 start-0 mt-1 w-100' style={{ zIndex: 9999 }}>
                      <div className='alert alert-danger alert-sm py-1 mb-0 d-flex align-items-center'>
                        <i className='fas fa-exclamation-circle me-2'></i>
                        <small>{barcodeError}</small>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {canAddLine && !isPosted && (
                <button
                  type='button'
                  className='btn btn-theme btn-sm d-flex align-items-center justify-content-center px-3 w-100 w-md-auto'
                  onClick={handleAddLine}
                >
                  <i className='fas fa-plus me-2'></i>
                  <span>{t('AddItem')}</span>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* ✅ Table */}
        <div className='card-body p-0'>
          <div
            className='table-responsive'
            style={{ maxHeight: '350px', overflowY: 'auto', overflowX: 'auto', position: 'relative' }}
          >
            <table className='table table-hover mb-0' style={{ minWidth: showUnitPrice ? '1100px' : '1000px' }}>
              <thead
                className='shadow fw-bold'
                style={{
                  position: 'sticky',
                  top: 0,
                  // zIndex: 101,
                  backdropFilter: 'blur(30px)'
                }}
              >
                <tr>
                  <th
                    className='text-center small shadow'
                    style={{ width: '50px', minWidth: '50px', position: 'sticky', left: 0, zIndex: 102 }}
                  >
                    #
                  </th>

                  <th className='text-center small' style={{ width: '400px', minWidth: '400px' }}>
                    {t('ItemName')}
                  </th>

                  <th className='text-center small' style={{ width: '110px', minWidth: '110px' }}>
                    {t('Unit')}
                  </th>

                  <th className='text-center small' style={{ width: '120px', minWidth: '120px' }}>
                    {t('LotNumber')}
                  </th>

                  {showUnitPrice && (
                    <th className='text-center small' style={{ width: '100px', minWidth: '100px' }}>
                      {t('UnitPrice')}
                    </th>
                  )}

                  <th className='text-center small' style={{ width: '80px', minWidth: '80px' }}>
                    {t('Quantity')}
                  </th>

                  <th className='text-center small' style={{ width: '70px', minWidth: '70px' }}></th>
                </tr>
              </thead>

              <tbody className='fw-bold'>
                {Lines?.length > 0 ? (
                  Lines.map((line: any, idx: number) => {
                    const Index = idx;
                    const infoExact = getInfoExact(line);
                    const infoLoose = infoExact || getInfoAnyByItemId(line?.transactionItemId);

                    const itemName = line.transactionItemId ? getItemNameForLine(line) : '';
                    const uomName = line.transactionItemId ? getUomNameForLine(line) : '';
                    const barcode = line.transactionItemId ? getBarcodeForLine(line) : '-';

                    const isDuplicate =
                      line.transactionItemId &&
                      line.transactionUom &&
                      lineHasDuplicateItemUom(line.transactionItemId, line.transactionUom, Index);

                    const uomOptions = line.transactionItemId
                      ? uomsByItemId.get(String(line.transactionItemId)) || []
                      : [];

                    const lots = Array.isArray((infoExact as any)?.qtyByLot) ? (infoExact as any).qtyByLot : [];
                    const allRow = {
                      lotId: null,
                      lotNumber: i18n.language === 'en' ? 'All' : 'الكل',
                      expirationDate: null,
                      qty: lots.reduce((s: number, x: any) => s + n(x?.qty), 0)
                    };
                    const lotRowsWithAll = lots.length > 0 ? [allRow, ...lots] : [allRow];

                    const selectedLot =
                      lotRowsWithAll.find((x: any) => String(x?.lotId ?? '') === String(line.lotId ?? '')) ?? allRow;

                    const availableQty = getAvailableQtyForLine(line);
                    const maxAllowed = getMaxAllowedQty(line);
                    const negativeAllowedByItem = getNegativeSellingAllowedForLine(line);

                    const qtyDisabled = isPosted || !canEditQty || !line.transactionItemId;

                    const displayNo = Index + 1;

                    return (
                      <tr key={line?.id ?? Index}>
                        {/* ✅ sticky # */}
                        <td
                          className='text-center align-middle bg-body shadow'
                          style={{ position: 'sticky', left: 0, zIndex: 100 }}
                        >
                          <span className='badge bg-theme bg-opacity-80 fw-bold' style={{ fontSize: '0.85rem' }}>
                            {displayNo}
                          </span>
                        </td>

                        {/* ✅ Item cell */}
                        <td className='align-middle'>
                          <div style={{ width: '100%' }}>
                            <div className={`p-2 border ${isDuplicate ? 'border-danger' : 'border-theme'} bg-body`}>
                              <div className='d-flex align-items-start gap-2'>
                                <div className='flex-grow-1' style={{ minWidth: 0 }}>
                                  {line.transactionItemId ? (
                                    <>
                                      <span className='fw-bold text-truncate d-block'>
                                        {itemName ? (
                                          itemName
                                        ) : detailsLoading ? (
                                          <span className='text-muted'>
                                            <span className='spinner-border spinner-border-sm me-2'></span>
                                            {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                                          </span>
                                        ) : (
                                          `ID: ${line.transactionItemId}`
                                        )}
                                      </span>

                                      <small className='text-muted d-block'>
                                        {t('Unit')}: <span className='fw-bold text-theme'>{uomName || '-'}</span>
                                        <span className='mx-2'>•</span>
                                        {t('Barcode')}: <span className='fw-bold'>{String(barcode).slice(0, 40)}</span>
                                      </small>
                                    </>
                                  ) : (
                                    <span className='text-muted'>{t('Choose')}</span>
                                  )}

                                  {isDuplicate && (
                                    <small className='text-danger d-block mt-1'>
                                      <i className='fas fa-exclamation-triangle me-1'></i>
                                      {t('هذا الصنف مكرر مع نفس الوحدة')}
                                    </small>
                                  )}
                                </div>

                                {/* Actions */}
                                <div className='d-flex gap-1'>
                                  <button
                                    disabled={isPosted || !canPickItem || !values.inventoryId}
                                    type='button'
                                    className='btn btn-sm btn-theme rounded-0'
                                    onClick={() => openPickerForLine(Index)}
                                    title={!values.inventoryId ? t('يجب اختيار المخزن أولاً.') : t('اختيار صنف ووحدة')}
                                  >
                                    <i className='fas fa-search me-1'></i>
                                    {line.transactionItemId ? t('تغيير') : t('اختيار')}
                                  </button>

                                  {line.transactionItemId && (
                                    <button
                                      disabled={isPosted || !canPickItem}
                                      type='button'
                                      className='btn btn-sm btn-outline-danger rounded-0'
                                      onClick={() => handleLineChange(Index, 'clearItem', true)}
                                      title={t('مسح الصنف')}
                                    >
                                      <i className='fas fa-times'></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* ✅ UOM */}
                        <td className='align-middle'>
                          <select
                            disabled={isPosted || !canChangeUom || !line.transactionItemId}
                            className={`form-select form-select-sm bg-body ${isDuplicate ? 'border-danger' : 'border-theme'}`}
                            value={line.transactionUom || ''}
                            onFocus={() => {
                              if (line.transactionItemId) ensureItemUomsLoaded(String(line.transactionItemId));
                            }}
                            onChange={e => handleLineChange(Index, 'transactionUom', e.target.value)}
                            style={{ width: '100%' }}
                          >
                            <option value=''>{t('Choose')}</option>

                            {line.transactionUom && uomOptions.length === 0 && (
                              <option value={line.transactionUom}>{uomName || line.transactionUom}</option>
                            )}

                            {uomOptions.map((u: any) => {
                              const uomVal = u.unitOfMeasure;
                              const label =
                                (i18n.language === 'en'
                                  ? u.unitOfMeasureName || u.unitOfMeasureName2
                                  : u.unitOfMeasureName2 || u.unitOfMeasureName) || `ID: ${uomVal}`;

                              return (
                                <option key={uomVal} value={uomVal}>
                                  {label}
                                </option>
                              );
                            })}

                            {uomsLoading && line.transactionItemId ? (
                              <option value={line.transactionUom || ''} disabled>
                                {i18n.language === 'en' ? 'Loading...' : '...جاري التحميل'}
                              </option>
                            ) : null}
                          </select>
                        </td>

                        {/* ✅ Lot */}
                        <td className='align-middle'>
                          {(() => {
                            const disabled = isPosted || !line.transactionItemId;
                            const lotLabel = selectedLot?.lotNumber || (i18n.language === 'en' ? 'All' : 'الكل');

                            return (
                              <div className='d-flex flex-column gap-1'>
                                <div
                                  className='input-group input-group-sm border border-theme'
                                  onClick={() => {
                                    if (disabled) return;
                                    openLotPicker(
                                      Index,
                                      lotRowsWithAll as any,
                                      line.lotId,
                                      itemName || `ID: ${line.transactionItemId}`
                                    );
                                  }}
                                  style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                >
                                  <input
                                    readOnly
                                    className='form-control form-control-sm  bg-body'
                                    value={lotLabel}
                                    placeholder={t('AllLots')}
                                    disabled={disabled}
                                  />
                                  <span className='input-group-text border-0 bg-body'>
                                    <i className='fas fa-caret-down'></i>
                                  </span>
                                </div>
                              </div>
                            );
                          })()}
                        </td>

                        {/* ✅ Unit Price (conditional) */}
                        {showUnitPrice && (
                          <td className='align-middle'>
                            <NumericFormat
                              value={Number(line.unitPrice || 0)}
                              thousandSeparator=','
                              decimalSeparator='.'
                              decimalScale={2}
                              allowNegative={false}
                              className='form-control form-control-sm text-center px-0 border-theme bg-body'
                              disabled={isPosted || !line.transactionItemId}
                              onValueChange={v => handleLineChange(Index, 'unitPrice', v.floatValue ?? 0)}
                            />
                          </td>
                        )}

                        {/* ✅ Qty */}
                        <td className='align-middle'>
                          <PopoverCustom
                            childern={
                              <NumericFormat
                                value={line.transactionQuantityIn}
                                thousandSeparator=','
                                decimalSeparator='.'
                                decimalScale={0}
                                allowNegative={false}
                                className='form-control form-control-sm text-center px-0 border-theme bg-body'
                                disabled={qtyDisabled}
                                onValueChange={v => handleLineChange(Index, 'transactionQuantityIn', v.floatValue ?? 0)}
                                onInput={(e: any) => {
                                  if (isPosted) return;
                                  const input = e.target as HTMLInputElement;
                                  const entered = Number(input.value.replace(/[^0-9]/g, ''));
                                  if (!Number.isFinite(maxAllowed)) return;
                                  if (entered > maxAllowed) input.value = String(maxAllowed);
                                }}
                              />
                            }
                            Header={
                              isPosted
                                ? i18n.language === 'en'
                                  ? `Posted Qty: ${n(line.transactionQuantityIn)} • Onhand now: ${availableQty}`
                                  : `الكمية المُرحلة: ${n(line.transactionQuantityIn)} • المتاح الآن: ${availableQty}`
                                : i18n.language === 'en'
                                  ? `Available: ${availableQty}`
                                  : `${t('AvailableQuantity')} : ${availableQty}`
                            }
                            Body={
                              !(infoExact || infoLoose) ? (
                                <div className='text-muted small'>
                                  {i18n.language === 'en' ? 'Details not loaded.' : 'لم يتم تحميل تفاصيل الصنف.'}
                                </div>
                              ) : isPosted ? (
                                <div className='d-flex flex-column gap-1'>
                                  <div className='d-flex justify-content-between'>
                                    <span>{i18n.language === 'en' ? 'Posted Qty' : 'الكمية المُرحلة'}</span>
                                    <span className='fw-bold text-theme'>{n(line.transactionQuantityIn)}</span>
                                  </div>

                                  <div className='d-flex justify-content-between'>
                                    <span>{i18n.language === 'en' ? 'Onhand now' : 'المتاح الآن'}</span>
                                    <span className='fw-bold text-success'>{availableQty}</span>
                                  </div>

                                  <div className='d-flex justify-content-between'>
                                    <span className='me-4'>{i18n.language === 'en' ? 'Selected Lot :' : 'رقم التشغيل : '}</span>
                                    <span className='fw-bold'>
                                      {selectedLot?.lotNumber || (i18n.language === 'en' ? 'All' : 'الكل')}
                                    </span>
                                  </div>

                                  <div className='d-flex justify-content-between'>
                                    <span className='me-4'>{i18n.language === 'en' ? 'Item Neg Stock' : 'بيع بالسالب :'}</span>
                                    <span className='fw-bold'>
                                      {negativeAllowedByItem
                                        ? i18n.language === 'en'
                                          ? 'Yes'
                                          : 'مسموح'
                                        : i18n.language === 'en'
                                          ? 'No'
                                          : 'غير مسموح'}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className='d-flex flex-column gap-1'>
                                  <div className='d-flex justify-content-between'>
                                    <span>{i18n.language === 'en' ? 'Max Allowed' : 'الحد المسموح'}</span>
                                    <span className='fw-bold text-theme'>{Number.isFinite(maxAllowed) ? maxAllowed : '∞'}</span>
                                  </div>

                                  <div className='d-flex justify-content-between'>
                                    <span>{i18n.language === 'en' ? 'Item Neg Stock' : 'سالب الصنف'}</span>
                                    <span className='fw-bold'>
                                      {negativeAllowedByItem
                                        ? i18n.language === 'en'
                                          ? 'Yes'
                                          : 'مسموح'
                                        : i18n.language === 'en'
                                          ? 'No'
                                          : 'غير مسموح'}
                                    </span>
                                  </div>

                                  <div className='d-flex justify-content-between'>
                                    <span>{i18n.language === 'en' ? 'Selected Lot' : 'اللوت المختار'}</span>
                                    <span className='fw-bold'>
                                      {selectedLot?.lotNumber || (i18n.language === 'en' ? 'All' : 'الكل')}
                                    </span>
                                  </div>
                                </div>
                              )
                            }
                          />
                        </td>

                        {/* ✅ Delete */}
                        <td className='align-middle text-center'>
                          {canDeleteLine && !isPosted ? (
                            <button
                              type='button'
                              className='btn btn-sm btn-danger rounded-0'
                              onClick={() => handleDeleteLine(Index)}
                              title={t('Delete Line')}
                              style={{ width: '28px', height: '28px', padding: '0' }}
                            >
                              <i className='fas fa-trash text-white'></i>
                            </button>
                          ) : (
                            <span className='text-muted'>-</span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={showUnitPrice ? 7 : 6} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {t('لا توجد أصناف مضافة')}
                      <br />
                      {canAddLine && !isPosted && (
                        <button type='button' className='btn btn-theme mt-3' onClick={handleAddLine}>
                          <i className='fas fa-plus me-2'></i>
                          {t('إضافة اول صنف')}
                        </button>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
            {Array.isArray(formik.errors.materialTransactionsLineList) && (
            <div className='bg-danger-subtle p-2 text-danger text-center small fw-bold'>
                      <small>
            {i18n.language === 'en'
              ? 'Some lines have missing or invalid data'
              : 'بعض البنود تحتوي على بيانات ناقصة أو غير صحيحة'}
          </small>
            </div>
          )}

         </div>

        {/* ✅ Card Footer */}
        <div className='card-footer d-flex justify-content-between align-items-center'>
          <div className='text-muted small'>
            <i className='fas fa-list me-1'></i>
            {t('عدد الأصناف')}: <span className='fw-bold'>{Lines?.length || 0}</span>
          </div>

          <div className='text-theme fw-bold'>
            <i className='fas fa-info-circle me-2'></i>
            {isPosted ? (i18n.language === 'en' ? 'Read only (Posted)' : 'قراءة فقط (مُرحّل)') : '-'}
          </div>
        </div>
      </Loading>

      {/* ✅ Lot Picker Modal */}
      <NeatixModal
        show={lotPickerOpen}
        setShow={(v: boolean) => (v ? setLotPickerOpen(true) : closeLotPicker())}
        bodyClassName='p-0'
        size='lg'
        showHeader={false}
        centered
      >
        <div className='p-3'>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <div className='fw-bold'>
              <i className='fas fa-layer-group me-2'></i>
              {i18n.language === 'en' ? 'Select Lot' : 'اختيار اللوت'}
              {lotPickerItemTitle ? <span className='text-muted ms-2'>— {lotPickerItemTitle}</span> : null}
            </div>

            <button type='button' className='btn btn-sm btn-outline-secondary' onClick={closeLotPicker}>
              <i className='fas fa-times'></i>
            </button>
          </div>

          <div className='input-group input-group-sm mb-2'>
            <span className='input-group-text'>{i18n.language === 'en' ? 'Search' : 'بحث'}</span>
            <input
              className='form-control'
              value={lotSearch}
              onChange={e => setLotSearch(e.target.value)}
              placeholder={i18n.language === 'en' ? 'Type lot number...' : 'اكتب رقم اللوت...'}
              autoFocus
            />
          </div>

          <div className='table-responsive' style={{ maxHeight: '55vh', overflow: 'auto' }}>
            <table className='table table-hover table-sm mb-0'>
              <thead className='bg-theme bg-opacity-10'>
                <tr>
                  <th style={{ width: '45%' }}>{t('LotNumber')}</th>
                  <th style={{ width: '35%' }}>{t('ExpirationDate')}</th>
                  <th className='text-end' style={{ width: '20%' }}>
                    {t('AvailableQuantity')}
                  </th>
                </tr>
              </thead>

              <tbody>
                {(filteredLotRows || []).map((r: any) => {
                  const isAll = r?.lotId == null;
                  const lotNo = isAll ? (i18n.language === 'en' ? 'All' : 'الكل') : r?.lotNumber || '-';
                  const exp = r?.expirationDate ? String(r.expirationDate).split('T')[0] : null;
                  const avail = n(r?.qty);

                  const active = String(lotPickerSelectedLotId ?? '') === String(r?.lotId ?? '');

                  return (
                    <tr
                      key={String(r?.lotId ?? 'ALL')}
                      role='button'
                      className={active ? 'table-active' : ''}
                      onClick={() => chooseLot(r?.lotId)}
                      style={{ cursor: 'pointer' }}
                    >
                      <td className='fw-bold'>{isAll ? <span className='text-theme'>{lotNo}</span> : lotNo}</td>
                      <td className='text-muted'>
                        {isAll ? '-' : exp || (i18n.language === 'en' ? 'No Exp' : 'بدون تاريخ')}
                      </td>
                      <td className='text-end fw-bold text-theme'>{avail}</td>
                    </tr>
                  );
                })}

                {(!filteredLotRows || filteredLotRows.length === 0) && (
                  <tr>
                    <td colSpan={3} className='text-center text-muted py-4'>
                      {i18n.language === 'en' ? 'No lots found.' : 'لا توجد لوتات مطابقة.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </NeatixModal>
    </>
  );
};

export default MoveLines;
